<template>
  <div class="web-proyector uvoto-dark-theme is-fullscreen">



    <div class="greetings-overlay">
      <transition-group name="greeting-float">
        <div v-show="saludo.nombre"
          v-for="saludo in saludosVisibles" 
          :key="saludo.id_instancia" 
          class="greeting-card-float"
          :style="saludo.estilo"
        >
          <div class="g-card-content">
            <div class="g-avatar-wrapper">
              <img :src="saludo.foto" class="g-avatar">
            </div>
            <div class="g-text-wrapper">
              <span class="g-name">{{ saludo.nombre }}</span>
              <p class="g-text">{{ saludo.texto }}</p>
            </div>
          </div>
        </div>
      </transition-group>
    </div>


    
    <transition name="fade">
      <div v-if="mostrandoSplash" class="splash-screen">
        <img :src="uiBrand.logoEmpresa ? uiBrand.logoEmpresa : require('../assets/uvoto.png')" class="splash-logo">
      </div>
    </transition>

    <div v-if="!mostrandoSplash" class="branding-background">
      <div class="logo-infinity-overlay">
        <img src="../assets/uvoto.png" class="infinity-logo">
      </div>
      <div class="bottom-gradient-mask"></div>
    </div>

    <button
            v-if="false"
            type="button"
            class="btn-user-desktop-entry"
            @click="irAUserDesktop"
          >
            Unirme a una sesión
          </button>

    <section v-if="!vinculado && !mostrandoSplash" class="welcome-screen">
       <div v-if="false" class="audio-bridge-control">
          <button @click="abrirModalAudio" class="btn-audio-pair" :class="{ 'connected': audioConectado }">
            <span v-if="!audioConectado" style="display: flex; align-items: center; justify-content: space-around;">
              <svg class="mic-icon" viewBox="0 0 24 24">
              <path class="fill-white" d="M12 14a3 3 0 003-3V5a3 3 0 10-6 0v6a3 3 0 003 3z"/>
              <path class="fill-white" d="M19 11a1 1 0 10-2 0 5 5 0 01-10 0 1 1 0 10-2 0 7 7 0 0014 0z"/>
              <path class="stroke-white" d="M12 19v3M8 22h8" stroke-width="2" stroke-linecap="round"/>
            </svg>
               <p style="margin: 4px;">{{ $t('proyector.conectar_audio') }}</p></span>
            <span v-else class="transmitting-text">
                <span class="audio-wave"><span></span><span></span><span></span></span>
                AUDIO PC ACTIVO
            </span>
          </button>
       </div>

        <transition name="pill-slide">
          <div v-if="mostrandoModalAudio" class="audio-connection-pill shadow-premium">
            <div class="pill-inner-content">
              
              <div class="pill-left-block">
                <div class="status-indicator">
                  <span class="pulse-ring"></span>
                  <span class="dot"></span>
                </div>
                <span class="instruction-text poppins-medium">
                  {{ $t('proyector.vincular_audio_instruccion') || 'Vincular Audio de Sistema' }}
                </span>
              </div>
              
              <div class="pill-right-block">
                <span class="pairing-code poppins-extrabold">{{ pairingCode }}</span>
                <button @click="mostrandoModalAudio = false" class="btn-close-pill">
                  ✕
                </button>
              </div>

            </div>
          </div>
        </transition>

      <div v-if="!audioConectado" class="hero-content animate-in" style="margin-bottom: 4%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <img src="../assets/uvoto.png" class="main-logo-landing" style="width: 25%;">
        <div class="pairing-container">
          <h1 class="poppins-bold">{{ $t('proyector.proyecta_sesion') }}</h1>
          <p class="subtitle">{{ $t('proyector.escanea_pin') }}</p>
          
          <div class="qr-pairing-wrapper">
             <vue-qr :text="urlVinculacion" :size="240" :margin="15" colorDark="#000000" class="qr-styled"></vue-qr>
             <div class="pin-info">
               <span>{{ $t('proyector.codigo_enlace') }}</span>
               <h2>{{ proyectorPin }}</h2>
             </div>
          </div>
        </div>
      </div>

      <!-- Estado transmitiendo -->
<div v-else class="hero-content audio-live-container">

  <img src="../assets/uvoto.png" class="main-logo-landing" style="width: 20%; margin-bottom:40px;">

  <div class="audio-live-box">

    <div class="audio-waves">

      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>

    </div>

    <h2 class="audio-live-title">
      <svg class="mic-icon" viewBox="0 0 24 24">
  <path class="fill-white" d="M12 14a3 3 0 003-3V5a3 3 0 10-6 0v6a3 3 0 003 3z"/>
  <path class="fill-white" d="M19 11a1 1 0 10-2 0 5 5 0 01-10 0 1 1 0 10-2 0 7 7 0 0014 0z"/>
  <path class="stroke-white" d="M12 19v3M8 22h8" stroke-width="2" stroke-linecap="round"/>
</svg>Transmitiendo audio
    </h2>

    <p class="audio-live-sub">
      El sonido del dispositivo está conectado a este proyector
    </p>

  </div>

</div>
      <footer class="minimal-footer">
        uvoto.com {{ $t('proyector.derechos') }} &nbsp;·&nbsp;
        <a href="https://uvoto.com/privacy#privacy-policy" target="_blank" class="minimal-footer-link">Privacy Policy</a>
        &nbsp;·&nbsp;
        <a href="https://uvoto.com/privacy#terms" target="_blank" class="minimal-footer-link">Terms of Service</a>
      </footer>
    </section>

     <main v-else-if="vinculado && !mostrandoSplash" class="projection-area is-tv-window" @mousemove="handleMouseMove">
      
     <header class="room-header animate-in">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 90%;">
          <div class="header-left">
            <img :src="uiBrand.logoEmpresa ? uiBrand.logoEmpresa : require('../assets/uvoto.png')" class="header-logo">
            <div class="header-divider"></div>
            <span class="live-status"><span class="pulse-dot-red"></span> {{ $t('proyector.en_vivo') }}</span>
          </div>

          <div class="audio-bridge-control" v-if="1>2">
          <button @click="abrirModalAudio" class="btn-audio-pair" :class="{ 'connected': audioConectado }">
            <span v-if="!audioConectado" style="display: flex; align-items: center; justify-content: space-around;">
              <svg class="mic-icon" viewBox="0 0 24 24">
                <path class="fill-white" d="M12 14a3 3 0 003-3V5a3 3 0 10-6 0v6a3 3 0 003 3z"/>
                <path class="fill-white" d="M19 11a1 1 0 10-2 0 5 5 0 01-10 0 1 1 0 10-2 0 7 7 0 0014 0z"/>
                <path class="stroke-white" d="M12 19v3M8 22h8" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <p style="margin: 4px;">{{ $t('proyector.conectar_audio') }}</p></span>
            <span v-else class="transmitting-text">
                <span class="audio-wave"><span></span><span></span><span></span></span>
                AUDIO PC ACTIVO
            </span>
          </button>
        </div>

       <transition name="pill-slide">
  <div v-if="mostrandoModalAudio" class="audio-connection-pill shadow-premium">
    <div class="pill-inner-content">
      
      <div class="pill-left-block">
        <div class="status-indicator">
          <span class="pulse-ring"></span>
          <span class="dot"></span>
        </div>
        <span class="instruction-text poppins-medium">
          {{ $t('proyector.vincular_audio_instruccion') || 'Vincular Audio de Sistema' }}
        </span>
      </div>
      
      <div class="pill-right-block">
        <span class="pairing-code poppins-extrabold">{{ pairingCode }}</span>
        <button @click="mostrandoModalAudio = false" class="btn-close-pill">
          ✕
        </button>
      </div>

    </div>
  </div>
</transition>
          <div class="header-right">
            <span class="room-label">{{ $t('proyector.sala') }}:</span>
            <span class="room-name poppins-bold">{{ tituloVisibleSesion }}</span>
          </div>
        </div>
      </header>

      <transition name="fade">
        <div
          v-if="showAudioUnlockOverlay"
          class="audio-unlock-overlay"
        >
          <div class="audio-unlock-card">
            <span class="audio-unlock-kicker">AUDIO</span>
            <h2 class="poppins-bold">Activa el sonido</h2>
            <p>Tu navegador necesita una interacción para reproducir el video con audio. Toca el botón para habilitarlo.</p>
            <button class="audio-unlock-btn" @click="desbloquearAudioProyector">
              Activar audio
            </button>
          </div>
        </div>
      </transition>

      <button v-if="isSystemFullscreen && esModoTV && 1>2" 
            class="exit-fs-btn" 
            :class="{ 'show': mouseMoving }"
            @click="esModoTV ? salirDeF11() : toggleFullScreen()">
          ✕ Esc
      </button>

      <transition name="fade-scale" mode="out-in">
        <div
  :key="modo"
  class="display-container"
  style="width: 100%; top: 0;"
  :style="[
    youtubeFullscreenActive
      ? {
          height: '100%', 
          position: 'fixed',
          zIndex: 999,
          margin: 'auto',
          top: '0',
          display: 'flex'
        }
      : {},
    modo === 'qr' && !canalConfig.projectionBranding
      ? { position: 'fixed' }
      : {}
  ]"
>

      

         <transition name="fade-bg">
            <div 
              v-if="uiBrand.Branding"
              :key="uiBrand.Branding"
              :class="claseAnimacion"
              class="tv-background-layer"
              :style="estiloProyector"
            >
              <img 
                v-if="esImagenBack(uiBrand.Branding)" 
                :src="uiBrand.Branding" 
                class="tv-bg-image"
              >

              <div 
                :style="!esImagenBack(uiBrand.Branding)?'opacity:0':''" 
                class="tv-bg-overlay"
              ></div>

             
                 
        <div 
            v-if="uiBrand?.logoEmpresa && uiBrand?.badgeRepeat !== false && !esImagenBack(uiBrand.Branding)" 
            class="logo-pattern-overlay"
            :style="{ backgroundImage: `url(${uiBrand.logoEmpresa})`, backgroundSize: '220px auto', }"
          ></div>
            </div>
            
          </transition>

          <div v-if="modo === 'logo'" class="centered content-over">
            <img src="../assets/uvoto.png" class="large-logo" style="width: 25%;">
            <p class="waiting-tag">{{ $t('proyector.esperando_inicio') }}</p>
          </div>

          <div v-else-if="modo === 'qr'" class="animate-in" style="width: 100%;">
             
            <div v-if="canalConfig.projectionBranding" 
                :class="['qr-branding-container', 'layout-style-' + (uiBrand.layoutStyle || 1)]">
              
              <div class="branding-media-side">
                <div :class="['media-wrapper', { 'video-background': uiBrand.layoutStyle == 3 }]">
                  <div v-if="esYoutube(canalConfig.projectionBranding)" :class="['video-fixed-container', { 'modo-cine': youtubeFullscreenActive }]">
                    <div id="youtube-player-proyector"></div>
                    <div class="yt-controls-block"></div>
                  </div>

                  <div v-else-if="esVideoStorage(canalConfig.projectionBranding)" :class="['video-fixed-container', { 'modo-cine': youtubeFullscreenActive }]">
                    <video
                      ref="storageVideo"
                      :key="canalConfig.projectionBranding"
                      :src="canalConfig.projectionBranding"
                      class="storage-video-player"
                      autoplay
                      playsinline
                      :loop="canalConfig.loopActivo"
                      :muted="lastMuteState"
                      style="width: 100%; height: 100%; object-fit: contain; background: #000;"
                    ></video>
                  </div>

                  <div v-if="esImagen(canalConfig.projectionBranding)" :class="['image-projection-wrapper', { 'fullscreen-mode': youtubeFullscreenActive }]">
                    <img :src="canalConfig.projectionBranding" class="branding-image-full">
                  </div>

                  <div
                    v-if="esPDF(canalConfig.projectionBranding)"
                    :class="['pdf-projection-wrapper', { 'pdf-fullscreen-mode': youtubeFullscreenActive, 'pdf-portrait': pdfIsPortrait }]"
                  >
                   <div class="pdf-canvas-bg" :style="youtubeFullscreenActive ? 'width: 100vw; height: 100vh; display: flex; justify-content: center; align-items: center;' : ''">
                    <canvas id="pdf-canvas" class="pdf-shadow-effect"></canvas>
                  </div>
                  </div>

                  <!-- Overlay de carga del PDF: fullscreen, fondo blureado + spinner -->
                  <transition name="pdf-loader-fade">
                    <div v-if="cargandoPDF" class="pdf-loading-overlay">
                      <div
                        class="pdf-loading-bg"
                        :style="pdfLoadingBg ? `background-image: url('${pdfLoadingBg}')` : ''"
                      ></div>
                      <div class="pdf-loading-veil"></div>
                      <div class="pdf-loading-content">
                        <div class="pdf-loading-spinner"></div>
                        <p class="pdf-loading-text">{{ $t('proyector.cargando_presentacion') }}</p>
                      </div>
                    </div>
                  </transition>
                </div>

                <div class="session-branding-footer" style="margin-top: 0; width: 100%;" v-if="uiBrand.layoutStyle != 3 && modo == 'qr'">
                  <template v-if="uiBrand.layoutStyle == 2">
                    <p class="session-branding-footer-centered">{{ $t('proyector.organizado_por') }}: <strong>{{ uiBrand.nombreEmpresa || 'Uvoto Branding' }}</strong></p>
                  </template>
                  <template v-else>
                    <h2 class="poppins-bold">{{ tituloVisibleSesion }}</h2>
                    <p>{{ $t('proyector.organizado_por') }}: <strong>{{ uiBrand.nombreEmpresa || 'Uvoto Branding' }}</strong></p>
                  </template>
                </div>
              </div>

              
             <transition name="fade-qr" mode="out-in">
             <div 
                class="qr-card-side" 
                v-if="uiBrand.layoutStyle != 2"
                key="qr-card"
              >
                <div :class="['qr-glass-card', 'shadow-glass', { 'qr-glass-card-aside': uiBrand.layoutStyle == 3 }]">
                  <template v-if="uiBrand.layoutStyle == 3">
                    <div class="qr-aside-shell">
                      <div class="qr-aside-top">
                        <div class="qr-aside-brand">
                          <img
                            :src="qrAsideLogoSrc"
                            :class="{ 'is-light': qrAsideLogoIsLight }"
                            alt=""
                          >
                        </div>
                        <span class="live-tag">ÚNETE</span>
                        <h1 class="poppins-bold">Escanea y participa</h1>
                      </div>

                      <div class="qr-body qr-body-aside">
                        <div class="qr-code-stage qr-code-stage-aside">
                          <vue-qr 
                            :text="urlVotacion" 
                            :size="800" 
                            :margin="20" 
                            colorDark="#000000" 
                            class="qr-responsive"
                          />
                          <div :class="['qr-logo-core', { 'is-dark-shell': qrAsideLogoIsLight || !uiBrand.logoEmpresa }]">
                            <img :src="uiBrand.logoEmpresa || require('../assets/icon-white.png')" alt="">
                          </div>
                        </div>
                      </div>

                      <div class="pin-display pin-display-aside">
                        <span class="pin-label">{{ $t('proyector.codigo') }}:</span>
                        <span class="pin-value">{{ codigoAccesoActivo }}</span>
                      </div>

                      <div class="qr-aside-points">
                        <p>Conéctate desde tu teléfono para opinar, responder y compartir tu momento en pantalla.</p>
                        <p>Escanea el código o entra a <strong>uvoto.com</strong> y escribe el PIN para unirte.</p>
                      </div>
                    </div>
                  </template>

                  <template v-else>
                    <div class="qr-header-v2">
                      <h1 class="poppins-bold qr-title-v2">
                        {{ $t('proyector.unete_a') }}<br>
                        <span class="qr-title-accent">{{ $t('proyector.la_sesion') }}</span>
                      </h1>
                      <p class="qr-subtitle-v2">Conéctate en segundos desde tu dispositivo</p>
                    </div>

                    <div class="qr-center-group">
                      <div class="qr-body">
                        <div class="qr-code-stage">
                          <vue-qr
                            :text="urlVotacion"
                            :size="800"
                            :margin="20"
                            colorDark="#000000"
                            class="qr-responsive"
                          />
                          <div :class="['qr-logo-core', { 'is-dark-shell': qrAsideLogoIsLight || !uiBrand.logoEmpresa }]">
                            <img :src="uiBrand.logoEmpresa || require('../assets/icon-white.png')" alt="">
                          </div>
                        </div>
                      </div>

                      <div class="qr-steps-h">
                        <div class="qr-step-h">
                          <div class="qr-step-h-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
                            </svg>
                          </div>
                          <span>Participa</span>
                        </div>
                        <div class="qr-step-h">
                          <div class="qr-step-h-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                            </svg>
                          </div>
                          <span>Responde</span>
                        </div>
                        <div class="qr-step-h">
                          <div class="qr-step-h-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <circle cx="12" cy="12" r="10"/>
                              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                            </svg>
                          </div>
                          <span>Pregunta</span>
                        </div>
                      </div>
                    </div>

                    <div class="qr-footer-v2">
                      <p class="qr-code-session-label">Ingresa el código en <strong>uvoto.com</strong></p>
                      <p class="qr-code-session-value">{{ codigoAccesoActivo }}</p>
                    </div>
                  </template>
                </div>
              </div>
            </transition>
            </div>

            <div v-else class="qr-tv-premium-layout animate-in" :class="{ 'has-custom-bg': canalConfig.projectionBranding }">
              

              <div class="tv-content-grid">
                <transition name="fade-slide">
                    <div class="tv-info-side" :class="{ 'is-hidden': uiBrand.textprewei === false }">
                    <div class="tv-badge">
                      {{ $t('proyector.sala_espera_activa') }}
                    </div>
                    <h1 class="tv-class-title highlight-text">
                      {{ $t('proyector.unete_sesion') }}:<br>
                      <span class="poppins-bold">{{ tituloVisibleSesion }}</span>
                    </h1>
                    <p class="tv-class-description">
                      {{ $t('proyector.instrucciones_tv') }}
                    </p>
                    
                    <div class="tv-host-info">
                      <div class="host-dot"></div>
                      <span style="color: white;">{{ $t('proyector.organizado_por') }}: <strong>{{ uiBrand.nombreEmpresa || 'Uvoto Branding' }}</strong></span>
                    </div>
                  </div>
                </transition>
               
                <transition name="fade-slide">
                  <div class="tv-qr-side" :class="{ 'is-hidden': uiBrand.qrprewei === false }">
                    <div class="tv-qr-floating-card">
                      <div class="tv-qr-container">
                        <div class="qr-code-stage qr-code-stage-tv">
                          <vue-qr :text="urlVotacion" :size="800" :margin="15" colorDark="#000000" class="qr-img-pro"></vue-qr>
                          <div :class="['qr-logo-core', 'qr-logo-core-tv', { 'is-dark-shell': qrAsideLogoIsLight || !uiBrand.logoEmpresa }]">
                            <img :src="uiBrand.logoEmpresa || require('../assets/icon-white.png')" alt="">
                          </div>
                        </div>
                      </div>
                      
                      <div class="tv-pin-footer">
                        <div class="tv-instruction-label">{{ $t('proyector.ingresa_en') }} <strong>uvoto.com</strong></div>
                        <div class="tv-pin-huge">{{ canalConfig.pin }}</div>
                        <div class="tv-code-hint">{{ $t('proyector.codigo_acceso') }}</div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>

            <div class="session-branding-footer" v-if="uiBrand.layoutStyle != 2 && modo != 'qr'" style="margin-left: 4%;" :style="divStyle">
              <h2 class="poppins-bold">{{ tituloVisibleSesion }}</h2>
              <p>{{ $t('proyector.organizado_por') }}: <strong>{{ uiBrand.nombreEmpresa || 'Uvoto Branding' }}</strong></p>
            </div>
          </div>

          <div
            v-else-if="modo === 'moments' && momentosProyectados.length"
            class="moments-stage animate-in"
            :class="['moments-style-' + momentsStyleActive, momentsViewportClass]"
          >
            <transition :name="momentsTransitionName" mode="out-in">
              <div :key="momentoActual?.id || momentsCurrentIndex" class="moment-scene" :class="momentsViewportClass">
                <div v-if="momentsStyleActive === 1" class="moment-layout split-layout">
                  <div class="moment-photo-shell">
                    <img :src="momentoActual.imageUrl" class="moment-main-photo">
                  </div>
                  <div class="moment-copy-shell">
                    <span class="moment-kicker">BREAK MOMENT</span>
                    <h2 class="moment-caption">{{ momentoActual.caption }}</h2>
                    <div class="moment-author-row">
                      <img v-if="momentoActual.foto" :src="momentoActual.foto" class="moment-author-avatar">
                      <div v-else class="moment-author-avatar placeholder">{{ (momentoActual.nombre || 'U')[0] }}</div>
                      <div class="moment-author-meta">
                        <strong>{{ momentoActual.nombre || 'Invitado' }}</strong>
                        <span>{{ tituloVisibleSesion || 'Uvoto Live' }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else-if="momentsStyleActive === 2" class="moment-layout polaroid-layout">
                  <div class="moment-polaroid-author-card">
                    <img
                      v-if="momentoActual.foto"
                      :src="momentoActual.foto"
                      class="moment-author-avatar"
                    >
                    <div v-else class="moment-author-avatar placeholder">
                      {{ (momentoActual.nombre || 'Invitado').charAt(0).toUpperCase() }}
                    </div>
                    <div class="moment-author-meta">
                      <strong>{{ momentoActual.nombre || 'Invitado' }}</strong>
                    </div>
                  </div>
                  <div class="polaroid-card" :class="['is-' + momentsCurrentOrientation]">
                    <img :src="momentoActual.imageUrl" class="moment-main-photo">
                    <div class="polaroid-caption">{{ momentoActual.caption }}</div>
                  </div>
                </div>

                <div v-else class="moment-layout cinematic-layout">
                  <div class="moment-bg-blur" :style="{ backgroundImage: `url(${momentoActual.imageUrl})` }"></div>
                  <div class="moment-cinematic-card">
                    <img :src="momentoActual.imageUrl" class="moment-main-photo cinematic-photo">
                    <div class="moment-cinematic-copy">
                      <span class="moment-kicker">MOMENTO DESTACADO</span>
                      <h2 class="moment-caption">{{ momentoActual.caption }}</h2>
                      <p class="moment-cinematic-author">{{ momentoActual.nombre || 'Invitado' }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <!-- ══════════ GANADORES ══════════ -->
          <div v-else-if="modo === 'ganadores'" class="ganadores-scene animate__animated animate__fadeIn">

            <!-- Partículas de fondo -->
            <div class="ganadores-particles" aria-hidden="true">
              <span v-for="p in 24" :key="p" class="gp-particle" :style="particleStyle(p)"></span>
            </div>

            <!-- ── PODIO (1–3 ganadores) ── -->
            <template v-if="ganadoresLista.length <= 3">
              <div class="podio-kicker poppins-bold">🏆 GANADORES DEL EVENTO</div>
              <p v-if="proyectorConfig.mensajeGanadores" class="podio-mensaje">{{ proyectorConfig.mensajeGanadores }}</p>

              <div class="podio-row">
                <div
                  v-for="slot in podioOrdenado"
                  :key="slot.idx"
                  class="podio-slot"
                  :class="`podio-slot--${slot.pos}`"
                  :style="{ animationDelay: slot.delay + 's' }"
                >
                  <!-- Avatar -->
                  <div class="podio-avatar-wrap">
                    <img
                      :src="slot.g.foto || avatarSeed(slot.g.nombre)"
                      class="podio-avatar"
                      :class="`podio-avatar--${slot.pos}`"
                    />
                    <span class="podio-medal">{{ slot.medal }}</span>
                  </div>
                  <!-- Nombre (solo primer nombre) -->
                  <div class="podio-nombre poppins-bold" :class="`podio-nombre--${slot.pos}`">
                    {{ primerNombre(slot.g.nombre) }}
                  </div>
                  <div class="podio-pts" :class="`podio-pts--${slot.pos}`">
                    {{ slot.g.puntos || 0 }} pts
                  </div>
                  <!-- Bloque del podio -->
                  <div class="podio-block" :class="`podio-block--${slot.pos}`">
                    <span class="podio-block-num">{{ slot.rank }}</span>
                  </div>
                </div>
              </div>
            </template>

            <!-- ── LEADERBOARD (>3 ganadores) ── -->
            <template v-else>
              <div class="lb-header">
                <div class="lb-header-left">
                  <span class="lb-trophy">🏆</span>
                  <div class="lb-title poppins-bold">Top {{ ganadoresLista.length }}</div>
                </div>
                <div class="lb-subtitle">Ranking de participación</div>
              </div>

              <div class="lb-list">
                <div
                  v-for="(g, i) in ganadoresLista"
                  :key="g.id || i"
                  class="lb-row animate__animated animate__fadeInLeft"
                  :class="{
                    'lb-row--gold':   i === 0,
                    'lb-row--silver': i === 1,
                    'lb-row--bronze': i === 2
                  }"
                  :style="{ animationDelay: (i * 0.07) + 's' }"
                >
                  <div class="lb-pos">
                    <span v-if="i < 3" class="lb-medal">{{ ['🥇','🥈','🥉'][i] }}</span>
                    <span v-else class="lb-num">{{ i + 1 }}</span>
                  </div>
                  <img :src="g.foto || avatarSeed(g.nombre)" class="lb-avatar" />
                  <div class="lb-info">
                    <div class="lb-nombre poppins-bold">{{ g.nombre }}</div>
                    <div class="lb-sub">{{ g.participaciones ? g.participaciones + ' participaciones' : '' }}</div>
                  </div>
                  <div class="lb-pts poppins-bold">
                    {{ g.puntos || 0 }}<span class="lb-pts-unit"> pts</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- ══════════ CARDS ══════════ -->
          <div v-else-if="modo === 'cards' && proyectorConfig.cardsData && proyectorConfig.cardsData.length" class="cards-projector-view content-over animate-in">
            <div class="cards-proj-grid">
              <div
                v-for="(card, i) in proyectorConfig.cardsData"
                :key="card.id || i"
                class="cards-proj-item"
                :style="{ height: cardItemHeight }"
              >
                <img v-if="card.imageUrl" :src="card.imageUrl" class="cards-proj-img" />
                <div v-else class="cards-proj-color-bg" :style="{ background: card.color || '#1a1a1a' }"></div>
                <div class="cards-proj-overlay"></div>
                <div class="cards-proj-vote-circle">
                  <span
                    class="cards-proj-vote-count"
                    :key="cardVotos[card.id || card.title || ('card_' + card.orden)] || 0"
                  >{{ cardVotos[card.id || card.title || ('card_' + card.orden)] || 0 }}</span>
                  <span class="cards-proj-vote-label">votos</span>
                </div>
                <div v-if="card.title" class="cards-proj-bottom">
                  <span class="cards-proj-text">{{ card.title }}</span>
                </div>
              </div>
            </div>
            <p class="cards-proj-label">{{ proyectorConfig.tituloCard || preguntaActiva?.titulo || '' }}</p>
          </div>
          <!-- ══════════════════════════════ -->

          <div v-else-if="(modo === 'pregunta' || modo === 'resultados' || modo === 'ordenar') && preguntaActiva" class="results-layout content-over animate-in">
            <h1 
  class="display-question" 
  :style="{
    fontSize: modo === 'pregunta' ? '50px' : '',
    marginBottom: modo === 'resultados' ? '15%' : ''
  }"
>
  {{ preguntaActiva.titulo }}
</h1>
           
            <div v-if="preguntaActiva.tipoContenido === 'ordenar'" class="sort-results-container">
              <div class="sort-ranking-grid">
                <div v-for="(item, i) in getSortedRanking" :key="i" 
                     class="ranking-item animate-up" 
                     :style="{ animationDelay: (i * 0.1) + 's' }">
                    
                    <div class="ranking-number" 
                         :style="{ 
                            background: i === 0 ? '#FFD700' : uiBrand.color,
                            color: i === 0 ? '#000' : '#fff',
                            transform: i === 0 ? 'scale(1.1)' : 'scale(1)'
                         }">
                        {{ i + 1 }}
                    </div>
                    
                    <div class="ranking-content">
                        <div class="ranking-main-info">
                            <span class="ranking-text">{{ item.nombre }}</span>
                            <span v-if="item.porcentajeFavorito > 0" class="favorito-tag">
                                🌟 {{ item.porcentajeFavorito }}% {{ $t('proyector.lo_puso_primero') }}
                            </span>
                        </div>

                        <div class="ranking-bar-bg">
                            <div class="ranking-bar-fill" 
                                 :style="{ 
                                    width: getPorcentajeOrden(item.puntos) + '%', 
                                    background: i === 0 ? 'linear-gradient(90deg, #FFD700, #FFA500)' : uiBrand.color 
                                 }">
                            </div>
                        </div>
                    </div>

                    <div class="ranking-stats">
                        <span class="ranking-pct poppins-bold">{{ getPorcentajeOrden(item.puntos) }}%</span>
                        <small class="points-label">{{ $t('proyector.score') }}</small>
                    </div>
                </div>
              </div>
            </div>


            <div v-else-if="preguntaActiva.tipoContenido === 'multichoice'" class="multi-results-container animate-in">
  <div class="multi-grid">
    <div v-for="(opt, i) in preguntaActiva.opciones" :key="i" class="multi-bar-item">
      <div class="multi-info">
        <span class="multi-label">{{ opt }}</span>
        <span class="multi-percentage poppins-bold">{{ getVotos(i) }} {{ $t('proyector.votos') || 'votos' }}</span>
      </div>
      <div class="multi-progress-bg">
        <div 
          class="multi-progress-fill" 
          :style="{ 
            width: getPorcentajeMulti(i) + '%', 
            background: uiBrand.color 
          }"
        >
          <div class="glow-effect"></div>
        </div>
      </div>
      <div class="multi-count">{{ getPorcentajeMulti(i) }}%</div>
    </div>
  </div>
</div>



<div v-else-if="preguntaActiva.tipoContenido === 'quiz' && proyectorConfig.preguntaActivaId" class="quiz-container animate-in">
  
 <div v-if="modo === 'pregunta'  && (tiempoRestanteQuiz > 0 || !preguntaActiva.fechaLanzamiento)" class="quiz-active-view">
  
  <div class="proyector-timer-wrapper" :class="{ 'timer-only-focus': modo === 'pregunta' }">
    <div class="timer-content">
      <span class="timer-seconds poppins-bold">
        {{ tiempoRestanteQuiz > 0 ? tiempoRestanteQuiz : preguntaActiva.duracion }}
      </span>
      <p v-if="modo === 'pregunta'" class="timer-label-focus">SEGUNDOS</p>
    </div>
  </div>

  <div v-if="modo !== 'pregunta'" class="multi-grid with-timer-active">
    <div v-for="(opt, i) in preguntaActiva.opciones" :key="i" class="multi-bar-item">
      <div class="multi-info">
        <span class="multi-label">{{ opt }}</span>
        <span class="multi-percentage">{{ getPorcentaje(i) }}%</span>
      </div>
      <div class="multi-progress-bg">
        <div class="multi-progress-fill" :style="{ width: getPorcentaje(i) + '%', background: uiBrand.color }"></div>
      </div>
    </div>
  </div>
  
</div>

  <div v-else-if="modo === 'pregunta' && tiempoRestanteQuiz === 0 && preguntaActiva.fechaLanzamiento && proyectorConfig.preguntaActivaId" class="closed-voting-view animate__animated animate__fadeIn">
    <div class="closed-content">
      <div class="icon-lock-wrapper">
        <svg class="lock-svg" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.5">
          <path d="M12 11V17M7 20H17C18.1046 20 19 19.1046 19 18V11C19 9.89543 18.1046 9 17 9H7C5.89543 9 5 9.89543 5 11V18C5 19.1046 5.89543 20 7 20ZM12 9V5C12 3.89543 11.1046 3 10 3H9C7.89543 3 7 3.89543 7 5V9H12Z" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h1 class="closed-title poppins-bold">VOTACIÓN CERRADA</h1>
      <p class="closed-subtitle poppins-medium">Conoceremos los resultados en breve...</p>
      <div class="loading-dots-minimal"><span></span><span></span><span></span></div>
    </div>
  </div>

  <div v-else-if="modo === 'resultados'" class="results-view-gala animate__animated animate__fadeIn">
    
    <div class="reveal-container animate__animated animate__zoomIn">
      <span class="reveal-label poppins-medium">LA RESPUESTA CORRECTA ES</span>
      <div class="reveal-glow"></div>
      <h2 class="reveal-answer poppins-bold">
        {{ preguntaActiva.opciones[preguntaActiva.respuestaCorrecta] }}
      </h2>
    </div>

    <div class="winners-footer" v-if="listaGanadores && listaGanadores.length > 0">
      <div class="slider-wrapper">
        <div class="slider-track">
          <div v-for="ganador in [...listaGanadores, ...listaGanadores]" :key="ganador.id + Math.random()" class="winner-card-minimal">
            <div class="card-glow"></div>
            <img :src="ganador.foto || `https://api.dicebear.com/7.x/initials/svg?seed=${ganador.nombre}`" class="user-photo">
            <div class="user-info">
              <span class="user-name poppins-bold">{{ ganador.nombre }}</span>
              <span class="user-tag poppins-medium">¡ACERTÓ!</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="position: absolute; margin: auto; margin-top: 10%; right: 0; left: 0; bottom: 20%;" v-else>
      <h3>Nadie respondio correctamente</h3>
    </div>

  </div>

 
  
</div>





            <div v-else-if="preguntaActiva.tipoContenido !== 'quiz'" class="charts-container" :style="modo === 'pregunta' ? 'margin-top:-10%;' : ''">
                <div v-for="(opt, i) in preguntaActiva.opciones" :key="i" class="bar-group">
                  <div class="bar-value">{{ getVotos(i) }}</div>
                    <div class="bar-wrapper" v-if="modo === 'resultados'">
                        
                        <div class="bar-fill" :style="{ height: getPorcentaje(i) + '%', background: uiBrand.color || 'white' }"></div>
                    </div>
                    <div class="option-indicator">{{ String.fromCharCode(65 + i) }}</div>
                    <div class="bar-label" :style="modo === 'pregunta' ? 'width: auto; margin-top: 20px; padding: 30px; min-width: 100px; border-radius: 10px; background:white; color:black;' : ''">
                        {{ opt }}
                    </div>
                </div>
            </div>
          </div>
        </div>
      </transition>

      

       <div class="logoCenter" v-if="modo !== 'qr' && modo !== 'conteo' && modo !== 'moments' && modo !== 'ganadores' && !proyectorConfig.preguntaActivaId && !preguntaActiva?.titulo">
    <img :src="proyectorConfig.logoEmpresa" alt="" style="width: 300px;">
    <p v-if="1>2">Modo de espera activado...</p>
  </div>

  <div class="logoCenter" v-if="modo !== 'qr' && modo !== 'conteo' && modo !== 'moments' && modo !== 'ganadores' && !proyectorConfig.preguntaActivaId && !preguntaActiva?.titulo && !proyectorConfig.logoEmpresa">
    <img src="../assets/uvoto.png" alt="" style="width: 300px;">
    <p >Uvoto Branding listening...</p>
  </div>


       <div v-if="vinculado && modo === 'conteo'" class="countdown-fullscreen">
    <transition name="pop" mode="out-in">
        <h1 :key="tiempoRestante" 
            class="timer-huge poppins-bold"
            :class="{ 'timer-paused': proyectorConfig?.ultimoConteo?.estado === 'pause' }">
            {{ formatTimer(tiempoRestante) }}
        </h1>
    </transition>
</div>

      <transition name="comment-pop" mode="out-in">
        <div v-if="vinculado && modo === 'comentario' && canalConfig.comentarioProyectado" 
            class="comentario-destacado-container"
            :key="canalConfig.comentarioProyectado.id">
          
          <div class="comentario-card-proyector">
            <div class="comentario-header">
              <div v-if="canalConfig.comentarioProyectado.foto" class="autor-foto">
                <img :src="canalConfig.comentarioProyectado.foto">
              </div>
              <div v-else class="autor-inicial" :style="{ background: uiBrand.color || '#00d4ff' }">
                {{ (canalConfig.comentarioProyectado.autor || 'A')[0] }}
              </div>

              <div class="autor-info-proyector">
                <h3>{{ canalConfig.comentarioProyectado.autor || $t('proyector.anonimo') }}</h3>
                
                <span v-if="canalConfig.comentarioProyectado.voto" class="voto-tag">
                  {{ $t('proyector.voto_por') }}: 
                  <strong style="text-transform: uppercase;">
                    {{ canalConfig.comentarioProyectado.voto }} ({{ preguntaActiva?.opciones[canalConfig.comentarioProyectado.voto.toLowerCase().charCodeAt(0) - 97] || '...' }})
                  </strong>
                </span>
              </div>
            </div>
            
            <div class="comentario-body">
              <p>"{{ canalConfig.comentarioProyectado.texto }}"</p>
            </div>

            <div class="comentario-footer-logo">
              <img src="../assets/uvoto.png" alt="uvoto">
            </div>
          </div>
        </div>
      </transition>

      <div class="live-reactions-container">
        <transition-group name="emoji-fly">
          <div 
            v-for="r in reaccionesVivas" 
            :key="r.id" 
            class="floating-emoji"
            :style="r.estilo"
          >
            {{ r.emoji }}
          </div>
        </transition-group>
      </div>

    </main>

    <div class="control-drawer-wrapper">
      <div class="control-drawer-content">
        <div class="drawer-handle">
          <div class="handle-icon"></div>
        </div>
        <div class="buttons-container">
          <button @click="isSystemFullscreen?salirDeF11():activarF11()" class="fs-toggle">
            <p>{{ isSystemFullscreen ? $t('proyector.salir_fs') : $t('proyector.entrar_fs') }}</p> 
            <span>⛶</span>
          </button>
          <button v-if="vinculado" @click="limpiarEstadoConexion" class="fs-toggle secondary">
            <p>{{ $t('proyector.cerrar_sesion') }}</p>
          </button>
        </div>
      </div>
    </div>


    <div class="security-gate-wrapper" v-if="!vinculado">
  <button 
  @mouseenter="manejarHoverEntrada" 
  @mouseleave="hoverActive = false"
  @click="toggleBloqueoManual"
  class="btn-lock-gate" 
  :class="{ 'is-locked': salaBloqueada }"
>
  <svg viewBox="0 0 24 24" width="24" height="24">
    <path v-if="salaBloqueada" fill="currentColor" d="M12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8H17V6A5,5 0 0,0 12,1A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M9,6A3,3 0 0,1 12,3A3,3 0 0,1 15,6V8H9V6M18,20H6V10H18V20Z" />
    
    <path v-else fill="currentColor" d="M18,8H17V6A5,5 0 0,0 12,1A5,5 0 0,0 7,6V8H9V6A3,3 0 0,1 12,3A3,3 0 0,1 15,6V8H18A2,2 0 0,0 20,10V20A2,2 0 0,0 18,22H6A2,2 0 0,0 4,20V10A2,2 0 0,0 6,8H7V8H18M18,10H6V20H18V10Z" />
  </svg>
</button>

  <transition name="slide-fade">
    <div v-if="hoverActive && salaBloqueada" class="security-info-tooltip">
      <span class="pin-displayed poppins-bold">{{ pinDinamico }}</span>
    </div>
  </transition>
</div>

  </div>
</template>

<script>
import { db } from '../firebase';
import { doc, onSnapshot, updateDoc, addDoc, setDoc, getDocs, collection, query, where, getDoc, orderBy, serverTimestamp, limit } from 'firebase/firestore';
import vueQr from 'vue-qr/src/packages/vue-qr.vue';
import { markRaw } from 'vue'; // Añade esto
import JSConfetti from 'js-confetti';
import * as pdfjsLib from 'pdfjs-dist'
import nlp from 'compromise';
// Usamos el CDN para el worker para evitar problemas de rutas relativas
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;



export default {
  components: { vueQr },
  
  data() {
    return {
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      mostrandoSplash: true,
      esModoTV: true,
      proyectorId: null,
      mouseMoving: false,
      timer: null,
      proyectorPin: '',
      vinculado: false,
      canalId: null,
      modo: 'qr',
      canalConfig: { color: '#6366f1', pin: '----', nombreEvento: '' },
      proyectorConfig: { 
        color: '#ffffff', 
        logo: '', 
        preguntaActivaId: null,
        nombreEvento: '',
        modo: 'standard',
        cardsData: []
      },
      preguntaActiva: null,
      preguntaCanalId: null,
      unsubProyector: null,
      unsubCanal: null,
      unsubPregunta: null,
       unsubCounters: null,
      deferredPrompt: null,
      mostrarPromptInstalacion: false,
      esTV: false,
      wakeLock: null,
      isSystemFullscreen: false,
      isF11: false,
      // Variables de Audio y Video
      lastMuteState: true,
      audioUnlocked: false,
      showAudioUnlockOverlay: false,
      volumeInterval: null,
      player: null,
      videoActualId: null,
      youtubeFullscreenActive: false,
      lastFullscreenTrigger: null,

      tiempoRestante: 0,      // El número que se ve en pantalla (60, 59, 58...)
      timerInterval: null,    // Referencia al setInterval para poder matarlo con clearInterval
      jsConfetti: null,       // Instancia de la librería de confeti
      audioPlayer: null,      // El objeto Audio para pausar/reproducir sonidos

      allGreetings: [],      // Todos los saludos descargados de Firestore
    saludosVisibles: [],   // Los 3 o 4 que se muestran actualmente
    indexCiclo: 0,         // Para saber cuál sigue en el bucle
    intervaloCiclo: null,
      audioPop: new Audio('https://assets.mixkit.co/active_storage/sfx/2358/2358-preview.mp3'), // Un sonido de burbuja suave
      reaccionesVivas: [], 
    unsubGreetings: null,

      //para el pdf
      pdfDoc: null,
      paginaActualRenderizada: 0,
      cargandoPDF: false,
      pdfLoadingBg: null,
      pdfIsPortrait: false,
      pdfPageCache: {},
      qrAsideLogoIsLight: false,

      salaBloqueada: false,
    hoverActive: false,
    pinDinamico: '',
    pinAccesoProyector: '----',


    mostrandoModalAudio: false,
    audioConectado: false,
    pairingCode: '',
    myNodeId: 'node_' + Math.random().toString(36).substr(2, 6),

    // Lógica de Procesamiento (Copiada de tu componente Admin)
    recognition: null,
    interimText: '',
    bufferLocal: '',
    acumuladorTexto: '',
    ultimaSincronizacion: Date.now(),
    recognitionRunning: false,
    ultimoTextoReconocido: '',
     ultimoMomentoClave: '',
    ultimoMomentoTimestamp: 0,

    votosVivos: {},
    participantesVivos: 0,
    cardVotos: {},
    unsubCardVotos: null,

      listaGanadores: [],
    unsubGanadores: null,
    tiempoRestanteQuiz: 0, 
    intervaloRelojProyector: null,
    momentsCurrentIndex: 0,
    momentsInterval: null,
    momentsCurrentOrientation: 'landscape',
    youtubeWatchdogTimer: null,
    youtubeLastState: null,
    youtubeLastRecoveryAt: 0,




   
    }
  },

watch: {
  // Cuando canalId se establece y ya estamos en modo cards, iniciar listener de votos
  canalId(newId) {
    if (newId && this.modo === 'cards') {
      this.escucharVotosCards();
    }
  },

  // 1. MONITOR DE MODO (QR, Pregunta, Conteo, Resultados)
  modo(nuevoModo) {
    
    // 🔥 Limpieza preventiva de recursos al cambiar de escena
    this.limpiarRecursosMedios();
    this.detenerConteo();
    this.detenerRelojProyector();

    if (nuevoModo === 'cards') {
      this.escucharVotosCards();
    } else {
      if (this.unsubCardVotos) { this.unsubCardVotos(); this.unsubCardVotos = null; }
      this.cardVotos = {};
    }

    // Si entramos a modo pregunta con quiz en ejecución, reanudar el reloj
    // (el detenerRelojProyector de arriba lo habría matado si la pregunta ya estaba cargada)
    if (nuevoModo === 'pregunta' &&
        this.preguntaActiva?.tipoContenido === 'quiz' &&
        this.preguntaActiva?.estado === 'ejecucion' &&
        this.preguntaActiva?.fechaLanzamiento) {
      this.iniciarRelojProyector();
    }

    // --- MODO QR ---
    if (nuevoModo === 'qr') {
      this.$nextTick(() => {
        // Usamos proyectorConfig que es la data real de tu componente
        this.inicializarMedioSegunURL(this.canalConfig?.projectionBranding);
      });
      return;
    }

    // --- MODO RESULTADOS ---
    if (nuevoModo === 'resultados' && this.preguntaActiva?.tipoContenido === 'quiz') {
      this.cargarGanadores();
    }

    if (nuevoModo === 'ganadores') {
      this.lanzarConfetti();
    }

    // --- MODO CONTEO ---
    if (nuevoModo === 'conteo') {
      const conteo = this.proyectorConfig?.ultimoConteo;
      if (!conteo) return;
      this.tiempoRestante = conteo.segundos;
      if (conteo.estado === 'play') {
        this.iniciarConteo();
      }
    }

    if (nuevoModo === 'moments') {
      this.iniciarRotacionMoments();
    } else {
      this.detenerRotacionMoments();
    }
  },

  // 2. MONITOR DE PREGUNTA ACTIVA (El corazón del Quiz)
  preguntaActiva: {
    immediate: true,
    deep: true,
    handler(newVal, oldVal) {
      // Caso A: Pregunta desaparece o finaliza
      if (!newVal || newVal.estado === 'finalizado') {
        this.detenerRelojProyector();
        this.tiempoRestanteQuiz = 0;
        return;
      }

      const esNuevaPregunta = newVal.id !== oldVal?.id;

      // Caso B: Pregunta nueva — detener reloj previo, arrancar solo si ya hay fechaLanzamiento
      if (esNuevaPregunta) {
        this.detenerRelojProyector();
        this.tiempoRestanteQuiz = 0;
        if (newVal.tipoContenido === 'quiz' && newVal.estado === 'ejecucion' && newVal.fechaLanzamiento) {
          this.iniciarRelojProyector();
        }
        return;
      }

      // Caso C: Misma pregunta — arrancar o reiniciar el reloj cuando llegue/cambie fechaLanzamiento
      // Esto cubre: latencia de serverTimestamp Y relanzamiento con nueva fechaLanzamiento
      if (newVal.tipoContenido === 'quiz' && newVal.estado === 'ejecucion') {
        const prevLaunch = oldVal?.fechaLanzamiento?.toMillis?.() ?? null;
        const newLaunch  = newVal.fechaLanzamiento?.toMillis?.() ?? null;
        if (newLaunch && (prevLaunch !== newLaunch || !this.intervaloRelojProyector)) {
          this.iniciarRelojProyector();
        }
      }
    }
  },

  lastMuteState(muted) {
    const vid = this.$refs.storageVideo;
    if (vid) vid.muted = muted;
  },

  // 3. MONITOR DE BRANDING (Vídeos, PDF, Imágenes de fondo)
  'canalConfig.projectionBranding': {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.limpiarRecursosMedios();
        this.$nextTick(() => {
          this.inicializarMedioSegunURL(newVal);
        });
      }
    }
  },

  // Cuando el admin activa/desactiva el loop, reiniciar el player de YouTube
  // para aplicar o quitar loop:1 + playlist en los playerVars
  'canalConfig.loopVideos'(newVal, oldVal) {
    if (newVal !== oldVal && this.esYoutube(this.canalConfig?.projectionBranding)) {
      // Forzar reinit aunque sea el mismo videoId
      this.videoActualId = null;
      this.limpiarRecursosMedios();
      this.$nextTick(() => {
        this.inicializarMedioSegunURL(this.canalConfig.projectionBranding);
      });
    }
  },

  // 4. MONITOR DE SALUDOS (Greetings)
  'canalConfig.greetings': {
    immediate: true, // Añadimos immediate para que funcione incluso si recargas la página
    handler(val) {
      if (val) {
        this.escucharGreetings();
        this.iniciarBuclePresentaciones();
      } else {
        this.detenerBuclePresentaciones();
      }
    }
  },

  // 5. CONTROL DE NAVEGACIÓN PDF
  'canalConfig.pdfPaginaActual': {
    handler(newVal) {

      if (this.pdfDoc) {
        this.renderizarPagina(newVal);
      } else if (this.esPDF(this.canalConfig?.projectionBranding) && !this.cargandoPDF) {
        console.log("Re-montando PDF por cambio de página...");
        this.cargarNuevoPDF(this.canalConfig.projectionBranding);
      }
    }
  },

  'proyectorConfig.momentsData': {
    deep: true,
    handler() {
      if (this.modo === 'moments') {
        this.iniciarRotacionMoments();
      }
    }
  },

  'proyectorConfig.logoEmpresa': {
    immediate: true,
    handler() {
      this.detectarLogoAsideLuminoso(this.qrAsideLogoSrc);
    }
  },

  'canalConfig.logoEmpresa'() {
    if (!this.proyectorConfig?.logoEmpresa) {
      this.detectarLogoAsideLuminoso(this.qrAsideLogoSrc);
    }
  },

  momentoActual: {
    immediate: true,
    handler(val) {
      if (val?.imageUrl) {
        this.prepararOrientacionMoment(val.imageUrl);
      }
    }
  }
},



  computed: {

    cardItemHeight() {
      const n = (this.proyectorConfig?.cardsData || []).length;
      return Math.ceil(n / 4) >= 2 ? '42vh' : '62vh';
    },

    ganadoresLista() {
      return this.proyectorConfig?.ganadoresDestacados || [];
    },
    podioOrdenado() {
      const lista = this.ganadoresLista;
      if (!lista.length) return [];
      const medals = ['🥇', '🥈', '🥉'];
      const pos    = ['oro', 'plata', 'bronce'];
      const orden  = lista.length === 1 ? [0] : lista.length === 2 ? [1, 0] : [1, 0, 2];
      const delay  = { 0: 0.7, 1: 0.2, 2: 0.45 };
      return orden.map(idx => ({
        idx,
        g:     lista[idx],
        pos:   pos[idx]    || 'bronce',
        medal: medals[idx] || '',
        rank:  idx + 1,
        delay: delay[idx]  ?? 0.2,
      }));
    },

    estiloFondo() {
      return {
        backgroundImage: this.config?.Branding,
        backgroundSize: '200% 200%',
        backgroundPosition: '0% 50%'
      };
    },

    shouldLockSharedBranding() {
      return this.proyectorConfig?.controlOwnerRole === 'panelista'
        && !!this.proyectorConfig?.hostCanalId
        && this.proyectorConfig.hostCanalId !== this.canalId;
    },

    uiBrand() {
      const base = this.canalConfig || {};
      const pinned = this.proyectorConfig || {};

      return {
        Branding: this.shouldLockSharedBranding ? (pinned.Branding || '') : (pinned.Branding || base.Branding),
        color: this.shouldLockSharedBranding ? (pinned.color || '#6366f1') : (pinned.color || base.color || '#6366f1'),
        logoEmpresa: this.shouldLockSharedBranding ? (pinned.logoEmpresa || '') : (pinned.logoEmpresa || base.logoEmpresa || ''),
        tituloVisible: this.shouldLockSharedBranding ? (pinned.tituloVisible || '') : (pinned.tituloVisible || base.tituloVisible || ''),
        nombreSesion: this.shouldLockSharedBranding
          ? (pinned.nombreSesion || pinned.nombreEvento || '')
          : (pinned.nombreSesion || pinned.nombreEvento || base.nombreSesion || base.nombreEvento || ''),
        nombreEmpresa: this.shouldLockSharedBranding ? (pinned.nombreEmpresa || '') : (pinned.nombreEmpresa || base.nombreEmpresa || ''),
        animation: this.shouldLockSharedBranding ? (pinned.animation || 'none') : (pinned.animation || base.animation || 'none'),
        layoutStyle: pinned.layoutStyle ?? base.layoutStyle ?? 1,
        textprewei: this.shouldLockSharedBranding ? (pinned.textprewei ?? true) : (pinned.textprewei ?? base.textprewei),
        qrprewei: this.shouldLockSharedBranding ? (pinned.qrprewei ?? true) : (pinned.qrprewei ?? base.qrprewei),
        badgeRepeat: this.shouldLockSharedBranding ? (pinned.badgeRepeat ?? true) : (pinned.badgeRepeat ?? base.badgeRepeat),
      };
    },

    claseAnimacion() {
      return {
        'anim-float-slow': this.uiBrand?.animation === 'floatSlow',
        'anim-move': this.uiBrand?.animation === 'move',
        'anim-pulse': this.uiBrand?.animation === 'pulse'
      };
    },

  estiloProyector() {
  const val = this.uiBrand?.Branding?.trim();

  if (!val || this.esImagenBack(val)) return {};

  // 🔥 Detecta gradients
  if (val.includes('gradient')) {

    // 🔥 NUEVO: detectar bokeh (radial gradients)
    const esBokeh = val.includes('radial-gradient');

    return {
      backgroundImage: val,

      // 🔥 CAMBIO CLAVE
      backgroundSize: esBokeh ? '150% 150%' : 'cover',
      backgroundPosition: esBokeh ? '0% 50%' : 'center',

      backgroundRepeat: 'no-repeat',

      // 🔥 opcional pero mejora visual
      ...(esBokeh && { backgroundBlendMode: 'screen' })
    };
  }

  // Color plano (igual que antes)
  return { backgroundColor: val };
},


    divStyle() {
    return this.screenWidth > 1920
      ? { margin: 'auto' }
      : {}
  },

  qrAsideLogoSrc() {
    return this.uiBrand.logoEmpresa || require('../assets/uvoto.png');
  },

  audienceCanalId() {
    if (this.shouldLockSharedBranding) {
      return this.proyectorConfig?.hostCanalId || this.canalId;
    }
    return this.canalId;
  },

 codigoAccesoActivo() {
    return this.proyectorConfig?.ownerPinCanal
      || this.proyectorConfig?.pinCanal
      || this.canalConfig?.pin
      || '----';
  },

  tituloVisibleSesion() {
    return (this.uiBrand?.tituloVisible || '').trim()
      || this.uiBrand?.nombreSesion
      || this.$t('proyector.sesion_activa');
  },

  //calcular los puntos favoritos del publico segun el orden que eligieron
   getSortedRanking() {
  if (!this.preguntaActiva || !this.preguntaActiva.votosOrden) return [];

  const statsPorOpcion = {};
  this.preguntaActiva.opciones.forEach(opt => {
    statsPorOpcion[opt] = { puntos: 0, favoritoCount: 0 };
  });

  const votos = Object.values(this.preguntaActiva.votosOrden || {});
  const totalVotantes = votos.length;
  
  votos.forEach(votoUsuario => {
    votoUsuario.forEach((nombreItem, index) => {
      if (statsPorOpcion[nombreItem] !== undefined) {
        // 1. Cálculo de puntos para el ranking general
        const puntosVoto = this.preguntaActiva.opciones.length - index;
        statsPorOpcion[nombreItem].puntos += puntosVoto;

        // 2. NUEVO: Contar si fue puesto de #1
        if (index === 0) {
          statsPorOpcion[nombreItem].favoritoCount += 1;
        }
      }
    });
  });

  return Object.entries(statsPorOpcion)
    .map(([nombre, stats]) => ({ 
      nombre, 
      puntos: stats.puntos, 
      // Calculamos qué % del total de personas lo puso de primero
      porcentajeFavorito: totalVotantes > 0 
        ? Math.round((stats.favoritoCount / totalVotantes) * 100) 
        : 0
    }))
    .sort((a, b) => b.puntos - a.puntos);
},

    urlVinculacion() { return `https://uvoto.com/user/bind?id=${this.proyectorId}`; },
   
    urlVotacion() {
      const shareSlug = String(
        this.proyectorConfig?.shareSlug
        || this.canalConfig?.shareSlug
        || ''
      ).trim();
      const origin = 'https://uvoto.com';
      if (shareSlug) return `${origin}/u/${shareSlug}`;

      const canalAudiencia = this.proyectorConfig?.ownerCanalId
        || this.audienceCanalId;
      return `${origin}/user/?canal=${canalAudiencia}`;
    },
    momentosProyectados() {
      return Array.isArray(this.proyectorConfig?.momentsData) ? this.proyectorConfig.momentsData : [];
    },
    momentoActual() {
      if (!this.momentosProyectados.length) return null;
      return this.momentosProyectados[this.momentsCurrentIndex] || this.momentosProyectados[0];
    },
    momentsStyleActive() {
      return Number(this.proyectorConfig?.momentsStyle || 1);
    },
    momentsViewportClass() {
      const width = this.screenWidth || window.innerWidth || 0;
      const height = this.screenHeight || window.innerHeight || 1;
      const ratio = width / Math.max(height, 1);

      if (width <= 640 || height <= 520) return 'is-compact';
      if (ratio >= 2.1) return 'is-ultrawide';
      if (ratio <= 0.85) return 'is-portrait-stage';
      if (ratio <= 1.2) return 'is-square-stage';
      return 'is-standard-stage';
    },
    momentsTransitionName() {
      if (this.momentsStyleActive !== 2) return 'moments-fade';
      return this.momentsCurrentIndex % 2 === 0 ? 'polaroid-swing-left' : 'polaroid-swing-right';
    },
  },

  created(){
    window.addEventListener('resize', this.updateWidth)
  },




  async mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    document.addEventListener('fullscreenchange', () => {
      this.isSystemFullscreen = !!document.fullscreenElement;
      this.isF11 = !!document.fullscreenElement; 

      if (this.pdfDoc && this.canalConfig?.pdfPaginaActual) {
        this.renderizarPagina(this.canalConfig.pdfPaginaActual);
      }
    });

   
    this.detectarDispositivo();


    

    setTimeout(() => { this.mostrandoSplash = false; }, 2000);
    await this.inicializarProyector();

    window.addEventListener('keydown', this.handleKeydown);
    window.addEventListener('pointerdown', this.registrarGestoAudio);
    this.activarWakeLock();
  },

  beforeUnmount() {
     window.removeEventListener('beforeunload', this.handleBeforeUnload)
    window.removeEventListener('resize', this.updateWidth);
    window.removeEventListener('keydown', this.handleKeydown);
    window.removeEventListener('pointerdown', this.registrarGestoAudio);
    this.limpiarTodoElEstado(); // Limpia canales, greetings, audio y pdf
    if (this.unsubProyector) this.unsubProyector();
    if (this.unsubCanal) this.unsubCanal();
    if (this.unsubPregunta) this.unsubPregunta();
    if (this.volumeInterval) clearInterval(this.volumeInterval);
    if (this.unsubCounters) {
      this.unsubCounters();
      this.unsubCounters = null;
    }

    if (this.unsubGanadores) this.unsubGanadores();
    if (this.unsubCardVotos) this.unsubCardVotos();
    this.detenerRotacionMoments();
    this.detenerVigilanciaYoutube();
  },

  methods: {
irAUserDesktop() {
  this.$router.push({ path: '/user', query: { desktop: '1' } });
},

iniciarRotacionMoments() {
  this.detenerRotacionMoments();
  if (!this.momentosProyectados.length) return;
  this.momentsCurrentIndex = 0;

  if (this.momentosProyectados.length === 1) return;

  this.momentsInterval = setInterval(() => {
    this.momentsCurrentIndex = (this.momentsCurrentIndex + 1) % this.momentosProyectados.length;
  }, 6500);
},

detenerRotacionMoments() {
  if (this.momentsInterval) {
    clearInterval(this.momentsInterval);
    this.momentsInterval = null;
  }
},

prepararOrientacionMoment(imageUrl) {
  const img = new Image();
  img.onload = () => {
    this.momentsCurrentOrientation = img.height > img.width ? 'portrait' : 'landscape';
  };
  img.src = imageUrl;
},

iniciarRelojProyector() {
  if (this.intervaloRelojProyector) {
    clearInterval(this.intervaloRelojProyector);
    this.intervaloRelojProyector = null;
  }

  const calcular = () => {
    // Si no hay pregunta, detenemos
    if (!this.preguntaActiva) {
      this.tiempoRestanteQuiz = 0;
      this.detenerRelojProyector();
      return;
    }

    // 🔥 MANEJO DE LATENCIA: Si Firebase aún no manda el timestamp, 
    // mostramos el tiempo total para que no salga "VOTACIÓN CERRADA" por error.
    if (!this.preguntaActiva.fechaLanzamiento) {
      this.tiempoRestanteQuiz = this.preguntaActiva.duracion || 0;
      return;
    }

    try {
      const inicioMs = this.preguntaActiva.fechaLanzamiento.toMillis();
      const finMs = inicioMs + (this.preguntaActiva.duracion * 1000);
      const ahoraMs = Date.now();
      const diff = Math.min(
        Math.ceil((finMs - ahoraMs) / 1000),
        this.preguntaActiva.duracion
      );

      if (diff <= 0) {
        this.tiempoRestanteQuiz = 0;
        this.detenerRelojProyector();
      } else {
        this.tiempoRestanteQuiz = diff;
      }
    } catch (e) {
      console.error("Error tiempo proyector:", e);
      this.tiempoRestanteQuiz = this.preguntaActiva.duracion || 0;
    }
  };

  calcular();
  this.intervaloRelojProyector = setInterval(calcular, 1000);
},



detenerRelojProyector() {
  if (this.intervaloRelojProyector) {
    clearInterval(this.intervaloRelojProyector);
    this.intervaloRelojProyector = null;
  }
},



    escucharVotosRealTime(preguntaId) {
  // 1. Limpiar cualquier rastro anterior
  if (this.unsubVotos) {
    this.unsubVotos();
    this.unsubVotos = null;
  }
  
  // 2. Escuchar la subcolección 'counters' (shards)
  // Es mucho más eficiente que escuchar la colección de 'votos' uno por uno
  const countersRef = collection(db, `canales/${this.preguntaCanalId || this.canalId}/preguntas/${preguntaId}/counters`);

  this.unsubVotos = onSnapshot(countersRef, (snap) => {
    let votosTotales = {};
    let participantesTotales = 0;

    snap.docs.forEach(doc => {
      const data = doc.data();
      participantesTotales += (data.participantes || 0);
      
      if (data.votos) {
        Object.entries(data.votos).forEach(([indice, cantidad]) => {
          votosTotales[indice] = (votosTotales[indice] || 0) + cantidad;
        });
      }
    });

    // 3. Actualizar variables reactivas
    this.votosVivos = votosTotales; 
    this.participantesVivos = participantesTotales;
    
    console.log("📊 Votos actualizados:", this.votosVivos);
  });
},


    iniciarRelojSincronizado() {
  if (this.intervaloReloj) clearInterval(this.intervaloReloj);

  const tick = () => {
    if (!this.preguntaActiva?.fechaCreacion) return;

    const inicio = this.preguntaActiva.fechaCreacion.toMillis();
    const total = this.preguntaActiva.duracion * 1000;
    const ahora = Date.now();
    const diff = Math.ceil((inicio + total - ahora) / 1000);

    if (diff <= 0) {
      this.tiempoRestante = 0;
      clearInterval(this.intervaloReloj);
    } else {
      this.tiempoRestante = diff;
    }
  };

  tick();
  this.intervaloReloj = setInterval(tick, 1000);
},


   async cargarGanadores() {
  // Limpiamos la lista anterior y cualquier listener previo si existiera
  if (this.unsubGanadores) this.unsubGanadores();
  this.listaGanadores = [];

  console.log('Buscando ganadores para:', this.preguntaActiva?.id);
  
  if (!this.canalId || !this.preguntaActiva?.id) return;

  const q = query(
    collection(db, `canales/${this.preguntaCanalId || this.canalId}/preguntas/${this.preguntaActiva.id}/respuestas_quiz`),
    where("esCorrecta", "==", true),
    orderBy("fecha", "asc")
  );
  
  // Usamos onSnapshot para que los nombres aparezcan dinámicamente
  this.unsubGanadores = onSnapshot(q, (snap) => {
    // Deduplicar por usuarioId: nos quedamos con la respuesta más reciente de cada usuario.
    // Normalmente no debería haber duplicados (setDoc usa userId como docId),
    // pero esto protege contra datos históricos escritos con addDoc.
    const porUsuario = new Map();
    snap.docs.forEach(d => {
      const data = d.data();
      const uid = data.usuarioId || d.id;
      const existing = porUsuario.get(uid);
      if (!existing || (data.fecha?.toMillis?.() || 0) > (existing.fecha?.toMillis?.() || 0)) {
        porUsuario.set(uid, { id: d.id, ...data });
      }
    });
    this.listaGanadores = Array.from(porUsuario.values());
    console.log('Ganadores actualizados:', this.listaGanadores.length);
  });
},


    // ── Ganadores helpers ──
    primerNombre(nombre) {
      return (nombre || '').split(' ')[0] || nombre || '';
    },
    avatarSeed(nombre) {
      return `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(nombre || 'U')}`;
    },
    particleStyle(i) {
      const colors = ['#FFD700','#FF6B6B','#4ECDC4','#A8E063','#FF9FF3','#54A0FF','#FFA94D'];
      const c = colors[i % colors.length];
      return {
        left:              `${(i * 13 + 5) % 100}%`,
        background:        c,
        boxShadow:         `0 0 8px ${c}`,
        width:             `${5 + (i * 3) % 9}px`,
        height:            `${5 + (i * 3) % 9}px`,
        animationDelay:    `${(i * 0.25) % 5}s`,
        animationDuration: `${3.5 + (i * 0.18) % 3}s`,
      };
    },

    getPorcentajeMulti(index) {
  // participantesVivos es el número de personas que han interactuado con esta pregunta
  const totalPersonas = this.participantesVivos || 0;
  const votosOpcion = this.getVotos(index); // Tu método actual que suma los shards

  if (totalPersonas === 0) return 0;
  
  // Representa: "¿Qué porcentaje de la audiencia eligió esta opción?"
  return Math.round((votosOpcion / totalPersonas) * 100);
},

    async obtenerVotosDesdeShards(preguntaId) {

  const countersRef = collection(
    db,
    `canales/${this.preguntaCanalId || this.canalId}/preguntas/${preguntaId}/counters`
  );

  const snap = await getDocs(countersRef);

  let votos = {};
  let participantes = 0;

  snap.forEach(docu => {

    const data = docu.data();

    participantes += data.participantes || 0;

    if (data.votos) {

      Object.entries(data.votos).forEach(([k,v]) => {

        votos[k] = (votos[k] || 0) + v;

      });

    }

  });

  return { votos, participantes };

},
    

    handleBeforeUnload(event) {

  if (!this.audioConectado) return

  // ⚠️ Mostrar advertencia del navegador
  event.preventDefault()
  event.returnValue = ''

  // 🔴 Cerrar sesión en Firebase
  try {

    if (this.proyectorId) {

      const proyectorRef = doc(db,"proyectores",this.proyectorId)

      updateDoc(proyectorRef,{
        audioStatus:'desconectado',
        canalId:null
      })

    }

  } catch(e) {
    console.log("Error cerrando sesión",e)
  }

},


async abrirModalAudio() {
  try {
    const stream = await navigator.mediaDevices.getDisplayMedia({
      video: true,
      audio: true
    });

    stream.getVideoTracks().forEach(t => t.stop());
    this.audioStreamTemporal = stream;

    this.pairingCode = Math.floor(1000 + Math.random() * 9000).toString();
    this.mostrandoModalAudio = true;

    const proyectorRef = doc(db, "proyectores", this.proyectorId);

    await updateDoc(proyectorRef, {
      audioPairingCode: this.pairingCode,
      audioStatus: 'esperando',
      fechaAudio: serverTimestamp()
    });

    const unsub = onSnapshot(proyectorRef, (snap) => {
      const data = snap.data();

      if (data && data.audioStatus === 'vinculado') {
        this.audioConectado = true;
        this.mostrandoModalAudio = false;

        // 🔥 aquí inicia captura real
        this.iniciarCapturaAudioReal(this.audioStreamTemporal);

        unsub();
      }
    });

  } catch (e) {
    console.error("Error bridge:", e);
  }
},

  setupCapturador(stream) {

  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

  this.recognition = new SpeechRecognition();
  this.recognition.continuous = true;
  this.recognition.interimResults = true;
  this.recognition.lang = 'es-ES';

  this.recognition.onstart = () => {
    this.recognitionRunning = true;
    console.log("🎤 SpeechRecognition iniciado");
  };

  this.recognition.onresult = (event) => {

    let interim = '';

    for (let i = event.resultIndex; i < event.results.length; ++i) {

      if (event.results[i].isFinal) {
        this.procesarTextoFinal(event.results[i][0].transcript);
      } else {
        interim += event.results[i][0].transcript;
      }

    }

    this.interimText = interim;

    if (interim.split(" ").length > 20) {
      this.procesarTextoFinal(interim);
      this.interimText = '';
    }

  };

 // --- CUANDO EL MOTOR INICIA ---
this.recognition.onstart = () => {

  this.recognitionRunning = true
  this.restarting = false

  console.log("🎤 SpeechRecognition iniciado")

}


// --- CUANDO EL MOTOR SE DETIENE ---
this.recognition.onend = () => {

  this.recognitionRunning = false
  this.ultimoTextoReconocido = ''

  if (!this.audioConectado) return

  // evitar múltiples reinicios
  if (this.restarting) return

  this.restarting = true

  console.log("♻️ Motor se detuvo, reiniciando...")

  setTimeout(() => {

    if (this.audioConectado && !this.recognitionRunning) {

      try {

        this.recognition.start()

      } catch (e) {

        console.log("⚠️ Error reiniciando:", e)

        this.restarting = false

      }

    } else {

      this.restarting = false

    }

  }, 300)

}


// --- ERRORES DEL MOTOR ---
this.recognition.onerror = (event) => {

  console.log("⚠️ SpeechRecognition error:", event.error)

  // errores normales que no requieren reinicio inmediato
  if (event.error === "no-speech") return
  if (event.error === "aborted") return

  if (!this.audioConectado) return

  if (this.restarting) return

  this.restarting = true

  setTimeout(() => {

    try {

      this.recognition.start()

    } catch (e) {

      console.log("⚠️ Error reiniciando tras error:", e)

    }

    this.restarting = false

  }, 500)

}

  this.recognition.start();

},


procesarTextoFinal(textoRaw) {

  // 🔹 Refinamiento con compromise
  let docNLP = nlp(textoRaw);
  const muletillas = ['eh', 'este', 'bueno', 'o sea', 'digamos', 'mm', 'uh', 'ah', 'como que'];
  muletillas.forEach(m => docNLP.match(m).remove());

  let textoLimpio = docNLP.text().trim()
    .replace(/\s+/g, ' ')
    .replace(/^(.)/, (m) => m.toUpperCase());

  // 🔥 LIMPIAR tartamudeos y repeticiones del motor
  textoLimpio = this.limpiarRepeticiones(textoLimpio);

  if (textoLimpio.length <= 2) return;

  const palabrasActuales = textoLimpio.split(" ");

  let nuevasPalabras = palabrasActuales;

  // 🔥 comparar contra las palabras anteriores
  if (this.ultimoTextoReconocido) {

    const palabrasPrevias = this.ultimoTextoReconocido.split(" ");

    let indiceCoincidencia = 0;

    for (let i = 0; i < Math.min(palabrasPrevias.length, palabrasActuales.length); i++) {
      if (palabrasPrevias[i] === palabrasActuales[i]) {
        indiceCoincidencia++;
      } else {
        break;
      }
    }

    nuevasPalabras = palabrasActuales.slice(indiceCoincidencia);
  }

  // guardamos último bloque reconocido
  this.ultimoTextoReconocido = textoLimpio;

  if (nuevasPalabras.length === 0) return;

  const nuevoTexto = nuevasPalabras.join(" ");

  this.detectarMomentoClave(nuevoTexto);

  this.bufferLocal = nuevoTexto;

  this.acumuladorTexto += (this.acumuladorTexto ? ' ' : '') + nuevoTexto;

  if (this.canalConfig.escuchaActiva) {
    this.revisarUmbralesEnvio();
  }

},


detectarMomentoClave(texto) {

  // 🔹 limpiar repeticiones del motor de voz
  texto = this.limpiarRepeticiones(texto);

  const triggers = [
    "lo más importante",
    "esto es clave",
    "recuerden que",
    "tomen nota",
    "en resumen",
    "para concluir",
    "lo fundamental",
    "presten atención",
    "esto significa",
    "el punto es"
  ];

  const textoLower = texto.toLowerCase();

  const encontrado = triggers.find(t => textoLower.includes(t));

  if (!encontrado) return;

  // 🔥 evitar duplicados seguidos
  if (this.ultimoMomentoClave === texto) return;

  // 🔥 evitar spam si el speaker repite varias veces
  const ahora = Date.now();
  if (this.ultimoMomentoTimestamp && ahora - this.ultimoMomentoTimestamp < 8000) {
    return;
  }

  this.ultimoMomentoClave = texto;
  this.ultimoMomentoTimestamp = ahora;

  console.log("⭐ MOMENTO CLAVE DETECTADO:", texto);

  addDoc(collection(db, `canales/${this.canalId}/momentos_clave`), {
    texto,
    trigger: encontrado,
    fecha: serverTimestamp(),
    tipo: "detectado_automaticamente"
  });

},


limpiarRepeticiones(texto) {

  const palabras = texto.split(" ");
  const resultado = [];

  for (let i = 0; i < palabras.length; i++) {

    const actual = palabras[i];
    const siguiente = palabras[i+1];

    if (siguiente && siguiente.startsWith(actual)) {
      continue;
    }

    resultado.push(actual);
  }

  return resultado.join(" ");
},



  revisarUmbralesEnvio() {
    const palabrasEnEspera = this.acumuladorTexto.split(" ").length;
    const tiempoDesdeUltimaSubida = Date.now() - this.ultimaSincronizacion;

    if (palabrasEnEspera >= 60 || (tiempoDesdeUltimaSubida > 40000 && palabrasEnEspera > 2)) {
      this.enviarACloud();
    }
  },

  async enviarACloud() {
    const textoParaSubir = this.acumuladorTexto;
    this.acumuladorTexto = ''; 
    this.ultimaSincronizacion = Date.now();
    const contextoId = this.proyectorConfig?.activeContextId || this.canalConfig?.contexto_ia?.activeContextId || '';
    const contextoNombre = this.proyectorConfig?.activeContextName || this.canalConfig?.contexto_ia?.activeContextName || '';

    console.log(textoParaSubir);
    
    try {
      await addDoc(collection(db, `canales/${this.canalId}/contexto_vivo`), {
        texto: textoParaSubir,
        fecha: serverTimestamp(),
        tipo: 'escucha_pc_remoto', // Diferenciamos la fuente
        contextoId,
        contextoNombre
      });
      console.log("☁️ PC envió bloque refinado:", textoParaSubir);
    } catch (e) {
      this.acumuladorTexto = textoParaSubir + " " + this.acumuladorTexto;
    }
  },

 async iniciarCapturaAudioReal(stream) {
  try {

    if (!stream) {
      console.warn("⚠️ No hay stream de audio disponible");
      return;
    }

    console.log("🎧 Usando stream ya autorizado");
    

    this.setupCapturador(stream);

  } catch (e) {
    console.error("Error iniciando captura:", e);
  }
},





    manejarHoverEntrada() {
    if (!this.salaBloqueada) return;
    this.hoverActive = true;
    // El PIN ya fue generado al activar el candado — solo mostramos el tooltip
  },

  async generarPinSeguridad() {
    const chars = "1234567890";
    let nuevoPin = "";
    for (let i = 0; i < 4; i++) {
      nuevoPin += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    // Actualizar estado local (reactivo — declarado en data)
    this.pinDinamico = nuevoPin;

    // Guardar en Firebase: bloquear y escribir el nuevo PIN en un solo update
    if (this.proyectorId) {
      try {
        const proyectorRef = doc(db, "proyectores", this.proyectorId);
        await updateDoc(proyectorRef, {
          bloqueado: true,
          pinSeguridad: nuevoPin
        });
      } catch (e) {
        console.error("Error al actualizar PIN de seguridad:", e);
      }
    }
  },

  async toggleBloqueoManual() {
    this.salaBloqueada = !this.salaBloqueada;
    this.hoverActive = false;

    if (this.salaBloqueada) {
      // BLOQUEANDO: generar PIN fresco y guardarlo inmediatamente
      await this.generarPinSeguridad();
      this.hoverActive = true; // Mostrar tooltip con el PIN recién generado
    } else {
      // DESBLOQUEANDO: limpiar PIN
      this.pinDinamico = '';
      if (this.proyectorId) {
        const proyectorRef = doc(db, "proyectores", this.proyectorId);
        await updateDoc(proyectorRef, { bloqueado: false, pinSeguridad: '' });
      }
    }
  },


  // Método de bloqueo manual directo (puede usarse desde código si se necesita)
  async bloqueo() {
    this.salaBloqueada = true;
    this.hoverActive = false;
    await this.generarPinSeguridad();
    this.hoverActive = true;
  },
  


    /**
   * INICIAR O REANUDAR EL CONTEO
   */
  /**
 * INICIAR O REANUDAR EL CONTEO
 */
iniciarConteo() {
  // 1. Limpiamos cualquier intervalo previo para evitar que el tiempo corra doble
  if (this.timerInterval) {
    clearInterval(this.timerInterval);
    this.timerInterval = null;
  }

  // 2. Iniciamos sonido ambiente desde proyectorConfig (la fuente de verdad actual)
  const configConteo = this.proyectorConfig?.ultimoConteo;
  if (configConteo?.sonido === 'clock') {
    this.reproducirSonido('clock.mp3', true); // true para loop
  }

  // 3. Arrancamos el segundero
  this.timerInterval = setInterval(() => {
    // IMPORTANTE: Verificamos el estado directamente del proyector en cada segundo
    const estadoActual = this.proyectorConfig?.ultimoConteo?.estado;

    if (estadoActual === 'play' && this.tiempoRestante > 0) {
      this.tiempoRestante--;
      
      // Lógica de Redoble
      if (this.tiempoRestante === 3 && configConteo?.sonido === 'redoble') {
        this.reproducirSonido('redoble.mp3', false);
      }
    } else if (this.tiempoRestante <= 0) {
      // LLEGÓ A CERO
      this.finalizarConteo();
    } else if (estadoActual === 'pause') {
      // Si el estado cambió a pausa, nos detenemos
      this.pausarRelojLocal();
    }
  }, 1000);
},

/**
 * PAUSAR EL RELOJ
 */
pausarRelojLocal() {
  if (this.timerInterval) {
    clearInterval(this.timerInterval);
    this.timerInterval = null;
  }
  // Pausamos el audio si existe (Tic-Tac)
  if (this.audioPlayer) this.audioPlayer.pause();
},

/**
 * FINALIZAR (Al llegar a 0)
 */
finalizarConteo() {
  this.detenerConteo(); // Limpia intervalo y audio
  
  // Leemos si el admin activó confeti en este conteo específico
  if (this.proyectorConfig?.ultimoConteo?.confeti) {
    this.lanzarConfetti();
  } else {
    this.reproducirSonido('fin_tiempo.mp3', false);
  }
  
  console.log("⏰ Conteo finalizado en Proyector");
},

/**
 * DETENER TOTALMENTE (Limpieza general)
 */
detenerConteo() {
  if (this.timerInterval) {
    clearInterval(this.timerInterval);
    this.timerInterval = null;
  }
  if (this.audioPlayer) {
    this.audioPlayer.pause();
    this.audioPlayer = null;
  }
},

/**
 * GESTIÓN DE AUDIO
 */
reproducirSonido(nombreArchivo, loop = false) {
  try {
    if (this.audioPlayer) {
      this.audioPlayer.pause();
      this.audioPlayer = null;
    }

    // Ruta a tus assets
    const audioPath = require(`@/assets/sounds/${nombreArchivo}`);
    this.audioPlayer = new Audio(audioPath);
    this.audioPlayer.loop = loop;
    
    this.audioPlayer.play().catch(e => console.warn("Autoplay bloqueado:", e));
  } catch (e) {
    console.warn("Error cargando sonido:", nombreArchivo, e);
  }
},

/**
 * GESTIÓN DE CONFETI
 */
lanzarConfetti() {
  console.log('🎉 Lanzando confeti...');
  // Asumiendo que JSConfetti está importado globalmente o en el componente
  const jsConfetti = new JSConfetti();

  jsConfetti.addConfetti({
    confettiRadius: 8,
    confettiNumber: 800,
  });

  // Ajuste de Z-Index para que el canvas de confeti no tape todo si no es necesario
  setTimeout(() => {
    const canvas = document.querySelector('canvas');
    if (canvas) canvas.style.zIndex = '9999999';
  }, 50);

  // Limpieza automática
  setTimeout(() => {
    const canvas = document.querySelector('canvas');
    if (canvas && canvas.parentNode) {
      canvas.parentNode.removeChild(canvas);
    }
  }, 5000);
},

/**
 * FORMATEO MM:SS
 */
formatTimer(segundos) {
  const min = Math.floor(segundos / 60);
  const seg = segundos % 60;
  return `${min}:${seg < 10 ? '0' : ''}${seg}`;
},
    ////////////////////

 limpiarTodoElEstado() {
    console.log("🛑 Deteniendo procesos activos (Multimedia y Listeners)...");

    // 1. Detener Listeners de sub-colecciones
    if (this.unsubCanal) { this.unsubCanal(); this.unsubCanal = null; }
    if (this.unsubPregunta) { this.unsubPregunta(); this.unsubPregunta = null; }
    if (this.unsubGreetings) { this.unsubGreetings(); this.unsubGreetings = null; }

    // 2. Limpiar Multimedia (YouTube y PDF)
    this.limpiarRecursosMedios();

    // 3. Detener Animaciones y Bucles
    this.detenerBuclePresentaciones();
    this.reaccionesVivas = [];
    this.saludosVisibles = [];
    this.allGreetings = [];
    
    // 4. Resetear config visual (pero NO el canalId aquí)
    this.preguntaActiva = null;
    this.canalConfig = { color: '#6366f1', pin: '----', nombreSesion: '' };
    this.showAudioUnlockOverlay = false;
    
    if (this.volumeInterval) clearInterval(this.volumeInterval);
  },

    esImagenBack(valor) {
    if (!valor) return false;
    // Verifica si es una URL (empieza con http, https o data:image)
    return /^(http|https|data:image)/.test(valor);
  },

   escucharGreetings() {
      // Limpiar anterior si existía para no duplicar listeners
      if (this.unsubGreetings) this.unsubGreetings();

      const q = query(collection(db, `canales/${this.canalId}/greetings`), orderBy("fecha", "desc"), limit(30));
      
      this.unsubGreetings = onSnapshot(q, (snap) => {
        // Si ya no estamos vinculados, no procesar nada (doble seguridad)
        if (!this.vinculado) return;

        this.allGreetings = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        snap.docChanges().forEach((change) => {
          if ((change.type === "added" || change.type === "modified")) {
            const data = change.doc.data();
            if (data.reaccion) {
              this.lanzarReaccionPantalla(data.reaccion);
            }
          }
        });
      });
    },

  lanzarReaccionPantalla(emoji) {
    const id = Math.random().toString(36).substr(2, 9);
    const nuevaReaccion = {
      id,
      emoji,
      estilo: {
        left: (Math.random() * 30 + 65) + '%', // Salen más hacia la derecha como en los Lives
        fontSize: (Math.random() * 20 + 30) + 'px', // Tamaños variados
      }
    };

    this.reaccionesVivas.push(nuevaReaccion);

    // Sonido opcional muy corto para reacción (audio pooled — no network request por reacción)
    if (!this.lastMuteState) {
      if (!this._reaccionAudio) {
        this._reaccionAudio = new Audio('https://assets.mixkit.co/active_storage/sfx/3005/3005-preview.mp3');
        this._reaccionAudio.volume = 0.1;
      }
      this._reaccionAudio.currentTime = 0;
      this._reaccionAudio.play().catch(() => {});
    }

    // Desaparecer rápido (2 segundos de vuelo)
    setTimeout(() => {
      this.reaccionesVivas = this.reaccionesVivas.filter(r => r.id !== id);
    }, 2000);
  },

  iniciarBuclePresentaciones() {
  if (this.intervaloCiclo) return;
  
  this.intervaloCiclo = setInterval(() => {
    if (this.allGreetings.length === 0) return;

    const dataSaludo = this.allGreetings[this.indexCiclo % this.allGreetings.length];
    
    const nuevaInstancia = {
      ...dataSaludo,
      id_instancia: Math.random().toString(36).substr(2, 9),
      estilo: {
        // Randomizamos la posición horizontal (10% a 80%)
        left: Math.floor(Math.random() * 70) + 10 + '%',
        // Randomizamos un poco la escala para dar profundidad
        transform: `scale(${0.8 + Math.random() * 0.4})`,
        animationDuration: (8 + Math.random() * 4) + 's' // Entre 8 y 12 segundos para que sea lento
      }
    };

    this.saludosVisibles.push(nuevaInstancia);
    
    // REPRODUCIR SONIDO (Si no está muteado el proyector)
    if (!this.lastMuteState) {
      this.audioPop.volume = 0.2; // Volumen bajo para que no asuste
      this.audioPop.currentTime = 0;
      this.audioPop.play().catch(e => console.log("Audio block: ", e));
    }

    this.indexCiclo++;

    // Limpieza automática para no saturar la memoria del navegador
    setTimeout(() => {
      this.saludosVisibles = this.saludosVisibles.filter(s => s.id_instancia !== nuevaInstancia.id_instancia);
    }, 13000); // Un segundo más que la duración de la animación

  }, 4000); // Lanza uno cada 4 segundos para que dé tiempo de leer
},

  detenerBuclePresentaciones() {
    clearInterval(this.intervaloCiclo);
    this.intervaloCiclo = null;
    this.saludosVisibles = [];
  },



    //obtener el porcentaje segun el orden de las respuestas
    getPorcentajeOrden(puntos) {
  if (!this.preguntaActiva || !this.preguntaActiva.votosOrden) return 0;
  
  // 1. Calculamos el total de puntos repartidos entre TODOS los items
  const votos = Object.values(this.preguntaActiva.votosOrden);
  const totalVotantes = votos.length;
  if (totalVotantes === 0) return 0;

  // Suma de progresión aritmética: si son 3 items, cada usuario reparte 3+2+1 = 6 puntos.
  const n = this.preguntaActiva.opciones.length;
  const puntosTotalesRepartidos = totalVotantes * (n * (n + 1) / 2);

  // 2. El porcentaje es la parte de esos puntos totales que tiene este item
  return Math.round((puntos / puntosTotalesRepartidos) * 100);
},

    updateWidth() {
    this.screenWidth = window.innerWidth
    this.screenHeight = window.innerHeight
  },

    // ESTA ES LA FUNCIÓN CLAVE: Mata YouTube y PDF
  limpiarRecursosMedios() {
    console.log("🧹 Limpiando recursos de medios...");
    this.detenerVigilanciaYoutube();

    // 1. Matar YouTube
    if (this.player) {
      try {
        if (typeof this.player.stopVideo === 'function') this.player.stopVideo();
        if (typeof this.player.destroy === 'function') this.player.destroy();
      } catch (e) { console.warn("Error destruyendo YT:", e); }
      this.player = null;
      this.videoActualId = null;
    }
    if (this.volumeInterval) clearInterval(this.volumeInterval);

    // 2. Matar PDF
    if (this.currentRenderTask) {
      this.currentRenderTask.cancel();
      this.currentRenderTask = null;
    }
    if (this.pdfDoc) {
      // Intentar liberar memoria interna del worker de PDF.js
      if (typeof this.pdfDoc.cleanup === 'function') this.pdfDoc.cleanup();
      if (typeof this.pdfDoc.destroy === 'function') this.pdfDoc.destroy();
      this.pdfDoc = null;
    }

    // 3. Limpiar Canvas físicamente
    const canvas = document.getElementById('pdf-canvas');
    if (canvas) {
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      canvas.width = 0; // Colapsar el canvas para liberar VRAM
      canvas.height = 0;
    }

    this.cargandoPDF = false;
    this.paginaActualRenderizada = 0;
  },

    gestionarCargaContenido() {
    const url = this.canalConfig.projectionBranding;
    if (!url) return;

    if (this.esYoutube(url)) {
      this.prepararYoutubeAPI();
    } else if (this.esPDF(url)) {
      this.cargarNuevoPDF(url);
    }
  },

  inicializarMedioSegunURL(url) {
    console.log('por aqui se empezo algo');

    console.log(url);

    if (!url) return;
    if (this.esYoutube(url)) {
      this.prepararYoutubeAPI();
    } else if (this.esPDF(url)) {
      this.cargarNuevoPDF(url);
    }
  },

  // Avanza al siguiente video del loop directamente en el proyector,
  // sin depender del admin ni de Firestore. Funciona con el teléfono bloqueado.
  _avanzarLoopLocal() {
    // Leer lista fresca cada vez para reflejar cambios del historial
    const lista = (this.canalConfig?.historialMedia || [])
      .filter(item => item.tipo === 'video')
      .sort((a, b) => (b.ultimaVez || 0) - (a.ultimaVez || 0));

    if (!lista.length) return;

    // Encontrar posición actual por videoActualId (independiente de projectionBranding)
    const currentIdx = lista.findIndex(
      item => this.obtenerYoutubeID(item.url) === this.videoActualId
    );

    const nextIdx = ((currentIdx >= 0 ? currentIdx : 0) + 1) % lista.length;
    const nextItem = lista[nextIdx];
    const nextVideoId = nextItem ? this.obtenerYoutubeID(nextItem.url) : null;

    if (!nextVideoId) return;

    // Destruir player actual y crear el nuevo directamente
    // Resetear videoActualId para que el guard de "mismo video" no bloquee
    this.videoActualId = null;
    this.limpiarRecursosMedios();
    this.$nextTick(() => {
      this.videoActualId = nextVideoId;
      this.initPlayer(nextVideoId);
    });
  },


    esImagen(url) {
      if (!url) return false;
      const cleanUrl = url.split('?')[0].toLowerCase();
      const extensionesImagen = ['.jpg', '.jpeg', '.png', '.webp', '.gif', '.bmp', '.svg'];
      return extensionesImagen.some(ext => cleanUrl.endsWith(ext));
    },

    esPDF(url) {
      if (!url) return false;
      const cleanUrl = url.split('?')[0].toLowerCase();
      return cleanUrl.endsWith('.pdf');
    },

async cargarNuevoPDF(url) {
  if (!url) return;
  this.cargandoPDF = true;
  this.pdfLoadingBg = null;
  this.pdfPageCache = {};
  // Auto-fullscreen al cargar un PDF
  this.youtubeFullscreenActive = true;

  try {
    await this.esperarElemento('pdf-canvas');
    pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

    const loadingTask = pdfjsLib.getDocument({ url, disableRange: true });
    const rawDoc = await loadingTask.promise;
    this.pdfDoc = markRaw(rawDoc);

    // Render rápido de pág 1 a baja resolución para el fondo blureado del overlay
    try {
      const page = await rawDoc.getPage(1);
      const viewport = page.getViewport({ scale: 0.4 });
      const offscreen = document.createElement('canvas');
      offscreen.width = viewport.width;
      offscreen.height = viewport.height;
      await page.render({ canvasContext: offscreen.getContext('2d'), viewport }).promise;
      this.pdfLoadingBg = offscreen.toDataURL('image/jpeg', 0.75);
    } catch (e) { /* best-effort: el overlay muestra fondo oscuro si falla */ }

    // Notificar total de páginas al canal
    const canalRef = doc(db, "canales", this.canalId);
    await updateDoc(canalRef, { pdfTotalPaginas: this.pdfDoc.numPages });

    console.log(`📄 PDF cargado. Total páginas: ${this.pdfDoc.numPages}`);

    const paginaAValidar = this.canalConfig?.pdfPaginaActual || 1;
    const paginaFinal = paginaAValidar > this.pdfDoc.numPages ? 1 : paginaAValidar;
    await this.renderizarPagina(paginaFinal);

  } catch (error) {
    console.error('❌ Error cargando PDF:', error);
  } finally {
    this.cargandoPDF = false;
  }
},

// Método auxiliar para asegurar que el DOM está listo (muy útil en Smart TVs)
esperarElemento(id) {
  return new Promise(resolve => {
    const el = document.getElementById(id);
    if (el) return resolve(el);
    const observer = new MutationObserver(() => {
      const el = document.getElementById(id);
      if (el) {
        observer.disconnect();
        resolve(el);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
},

async renderizarPagina(numeroPagina) {
  if (!this.pdfDoc) return;
  const num = parseInt(numeroPagina);
  if (isNaN(num) || num < 1 || num > this.pdfDoc.numPages) return;

  const escalaBase = this.youtubeFullscreenActive ? 3.0 : 2.0;
  const cacheKey = `${num}_${escalaBase}`;

  try {
    // Si la página ya está en cache, la copiamos al canvas visible de golpe (sin flash)
    if (this.pdfPageCache[cacheKey]) {
      const cached = this.pdfPageCache[cacheKey];
      const canvas = await this.esperarElemento('pdf-canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = cached.width;
      canvas.height = cached.height;
      canvas.style.objectFit = 'contain';
      ctx.drawImage(cached, 0, 0);
      this.pdfIsPortrait = cached.height >= cached.width;
      this.paginaActualRenderizada = num;
      this.preCachearVecinos(num, escalaBase);
      return;
    }

    // Sin cache: renderizar en canvas oculto (double-buffer) para no mostrar pantalla blanca
    const page = await this.pdfDoc.getPage(num);
    const baseViewport = page.getViewport({ scale: 1 });
    this.pdfIsPortrait = baseViewport.height >= baseViewport.width;
    const viewport = page.getViewport({ scale: escalaBase });

    const offscreen = document.createElement('canvas');
    offscreen.width = viewport.width;
    offscreen.height = viewport.height;

    if (this.currentRenderTask) this.currentRenderTask.cancel();
    this.currentRenderTask = page.render({ canvasContext: offscreen.getContext('2d'), viewport, enableWebGL: true });
    await this.currentRenderTask.promise;

    // Guardar en cache
    this.pdfPageCache[cacheKey] = offscreen;

    // Copiar al canvas visible de una sola vez (sin flash)
    const canvas = await this.esperarElemento('pdf-canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    canvas.style.objectFit = 'contain';
    ctx.drawImage(offscreen, 0, 0);

    this.paginaActualRenderizada = num;
    this.preCachearVecinos(num, escalaBase);
  } catch (error) {
    if (error.name === 'RenderingCancelledException') return;
    console.error('❌ Error render proyector:', error);
  }
},

async preCachearVecinos(num, escalaBase) {
  if (!this.pdfDoc) return;
  const vecinos = [num + 1, num - 1].filter(n => n >= 1 && n <= this.pdfDoc.numPages);
  for (const n of vecinos) {
    const key = `${n}_${escalaBase}`;
    if (this.pdfPageCache[key]) continue;
    try {
      const page = await this.pdfDoc.getPage(n);
      const viewport = page.getViewport({ scale: escalaBase });
      const offscreen = document.createElement('canvas');
      offscreen.width = viewport.width;
      offscreen.height = viewport.height;
      const task = page.render({ canvasContext: offscreen.getContext('2d'), viewport, enableWebGL: true });
      await task.promise;
      this.pdfPageCache[key] = offscreen;
    } catch (e) { /* pre-cache best-effort */ }
  }
},


    handleMouseMove() {
      this.mouseMoving = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.mouseMoving = false; }, 3000);
    },

    async activarF11() {
      try {
        const elem = document.documentElement;
        if (elem.requestFullscreen) await elem.requestFullscreen();
      } catch (err) { console.error(err); }
    },

    async salirDeF11() {
      if (document.fullscreenElement) {
        try { await document.exitFullscreen(); } catch (err) { console.error(err); }
      }
    },

    async activarWakeLock() {
      if ('wakeLock' in navigator) {
        try {
          this.wakeLock = await navigator.wakeLock.request('screen');
        } catch (err) { console.warn('WakeLock fail'); }
      }
    },

    detectarDispositivo() {
      const ua = navigator.userAgent.toLowerCase();
      const esTVDeclarada = /(smart-tv|tizen|webos|roku|googletv|android tv|playstation|xbox)/.test(ua);
      this.esTV = esTVDeclarada;
    },

    async inicializarProyector() {
      const savedId = localStorage.getItem('proyector_id_persistente');
      if (savedId) {
        this.proyectorId = savedId;
        const snap = await getDoc(doc(db, "proyectores", savedId));
        if (snap.exists() && snap.data().estado === 'vinculado') this.escucharProyector();
        else await this.crearNuevaSesionProyector();
      } else await this.crearNuevaSesionProyector();
    },

    async crearNuevaSesionProyector() {
      localStorage.removeItem('proyector_id_persistente');
      let pinValido = false;
      let p = '';
      while (!pinValido) {
        p = Math.floor(1000 + Math.random() * 9000).toString();
        const q = query(collection(db, "proyectores"), where("pin", "==", p));
        const snap = await getDocs(q);
        if (snap.empty) pinValido = true;
      }
      this.proyectorPin = p;
      this.proyectorId = "proj_" + Math.random().toString(36).substring(7);
      await setDoc(doc(db, "proyectores", this.proyectorId), {
        pin: this.proyectorPin, estado: 'esperando', modo: 'logo', createdAt: new Date(),
        mute: true, os: this.detectarYGuardarOS(), bloqueado: false, pinSeguridad: ''
      });
      localStorage.setItem('proyector_id_persistente', this.proyectorId);
      this.escucharProyector();
    },



    detectarYGuardarOS() {
      const ua = navigator.userAgent;
      let os = 'Dispositivo';
    
      if (/Windows NT 10/.test(ua))       os = 'Windows 11';
      else if (/Windows NT 6\.3/.test(ua)) os = 'Windows 8.1';
      else if (/Windows/.test(ua))         os = 'Windows';
      else if (/Mac OS X/.test(ua) && !/iPhone|iPad/.test(ua)) {
        const match = ua.match(/Mac OS X ([\d_]+)/);
        os = match ? `macOS ${match[1].replace(/_/g, '.')}` : 'macOS';
      }
      else if (/CrOS/.test(ua))            os = 'ChromeOS';
      else if (/Linux/.test(ua))           os = 'Linux';
      else if (/Android/.test(ua))         os = 'Android';
      else if (/iPhone|iPad/.test(ua))     os = 'iOS';
    
      return os;
    },

    

    async limpiarEstadoConexion() {
      try {
        await this.desconectarProyector()
      } catch (error) {
        alert('Error al intentar cerrar la sesion '+ error)
        return
      }

      localStorage.removeItem('proyector_id_persistente');
      if (this.unsubProyector) this.unsubProyector();
      this.vinculado = false;
      
    },

   
    //cerrar seison de proyector 
    async desconectarProyector() {
      if (!this.proyectorId) return;
      try {
        const proyectorRef = doc(db, "proyectores", this.proyectorId);
        // En lugar de borrar el doc, lo reseteamos a estado de espera
        await updateDoc(proyectorRef, {
          estado: 'esperando',
          canalId: null,
          modo: 'logo'
        });

      } catch (e) {
        console.error("Error al desconectar:", e);
      }
    },

escucharProyector() {
  if (this.unsubProyector) this.unsubProyector();
  
  this.unsubProyector = onSnapshot(doc(db, "proyectores", this.proyectorId), (snap) => {
    if (!snap.exists()) return;
    
    const data = snap.data();
    const modoAnterior = this.modo; // Guardamos para comparar cambios
    
    // Guardamos la referencia para que las funciones de sonido/confeti puedan leerla
    this.proyectorConfig = data;
    this.modo = data.modo || 'qr'; // Sincronizamos el modo actual

    // Detectar nuevo lanzamiento de cards → resetear votos en pantalla
    if (data.modo === 'cards' && data.cardsData) {
      const newKey = String(data.cardsLaunchId || (data.cardsData || []).map(c => c.id || c.orden).join(','));
      if (newKey !== this._cardsSessionKey) {
        this._cardsSessionKey = newKey;
        this.cardVotos = {};
      }
    }


    
   if (data.preguntaActivaId == null) {
      // Cerrar el listener de la pregunta anterior para que cambios externos
      // (ej: panelista sin control relanzando su quiz) no afecten este proyector.
      if (this.unsubPregunta) {
        this.unsubPregunta();
        this.unsubPregunta = null;
      }
      this.preguntaActiva = null;
      this.detenerRelojProyector();
   }

    // --- 📊 LÓGICA DE VOTACIONES EN TIEMPO REAL (SHARDS) ---
    // Si el proyector entra en modo resultados, activamos los shards de la pregunta actual
    if (this.modo === 'resultados') {
      if (this.preguntaActiva?.id) {
        console.log("📊 Activando listener de votos (shards) para:", this.preguntaActiva.id);
        this.activarListenerVotos(this.preguntaActiva.id);
      }
    } else if (modoAnterior === 'resultados' && this.modo !== 'resultados') {
      // Si salimos de resultados, limpiamos el escuchador para ahorrar recursos
      console.log("🛑 Desactivando listener de votos.");
      this.desactivarListenerVotos();
    }

    // --- 🟢 NUEVA SINCRONIZACIÓN DE ÓRDENES DEL ADMIN ---
    if (data.escuchaActiva !== undefined) {
      this.canalConfig.escuchaActiva = data.escuchaActiva;
      console.log("🎤 Estado de escucha (Admin -> Proyector):", data.escuchaActiva ? 'ENCENDIDO' : 'APAGADO');
    }

    // --- ⏱️ INTEGRACIÓN MÓDULO CONTEO (Sin romper el flujo) ---
    if (this.modo === 'conteo' && data.ultimoConteo) {
      const uc = data.ultimoConteo;
      if (uc.segundosActuales !== undefined) {
        this.tiempoRestante = uc.segundosActuales;
      }
      if (uc.estado === 'play') {
        this.iniciarConteo(); 
      } else {
        this.pausarRelojLocal();
      }
    }

    // --- LÓGICA DE AUDIO BRIDGE ---
    if (data && data.audioStatus === 'vinculado') {
        this.audioConectado = true;
        this.mostrandoModalAudio = false;
        this.canalId = data.canalId; 
        if (!this.recognition) {
          this.setupCapturador(this.audioStreamTemporal);
        }
    }

    // --- DESCONEXIÓN DE AUDIO ---
    if (data.audioStatus !== 'vinculado' && this.audioConectado) {
      this.audioConectado = false;
      this.mostrandoModalAudio = false;
      if (this.recognition) {
        try {
          this.recognition.stop();
          this.audioStreamTemporal.getTracks().forEach(track => track.stop());
        } catch(e){}
        this.recognition = null;
      }
    }

    // Sincronización de Sonido (Mute)
    if (data.mute !== undefined && data.mute !== this.lastMuteState) {
      this.lastMuteState = data.mute;
      this.gestionarSonido(data.mute);
    }

    // CASO: EL ADMIN CERRÓ SESIÓN
    if (data.estado === 'esperando') {
      if (this.vinculado) {
        this.vinculado = false;
        this.limpiarTodoElEstado();
        this.canalId = null;
        // Resetear candado local — la nueva sesión empieza siempre desbloqueada
        this.salaBloqueada = false;
        this.pinDinamico = '';
        this.hoverActive = false;
        this.crearNuevaSesionProyector();
      }
      return;
    }

    // CASO: VINCULACIÓN EXISTENTE O NUEVA
    if (data?.canalId) {
      this.vinculado = true;
      this.preguntaCanalId = data.preguntaCanalId || null;
      if (data.preguntaActivaId && data.preguntaActivaId !== this.preguntaActiva?.id) {
          this.escucharPregunta(data.preguntaActivaId);
      }
      // Solo re-suscribir al canal si el canalId realmente cambió
      if (this.canalId !== data.canalId) {
        this.canalId = data.canalId;
        this.escucharCanal();
      }
    }
  });
},

    registrarGestoAudio() {
  this.audioUnlocked = true;
},

detectarLogoAsideLuminoso(src) {
  if (!src) {
    this.qrAsideLogoIsLight = false;
    return;
  }

  const img = new Image();
  img.crossOrigin = 'anonymous';

  img.onload = () => {
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      const sampleWidth = 48;
      const sampleHeight = 48;
      canvas.width = sampleWidth;
      canvas.height = sampleHeight;
      ctx.drawImage(img, 0, 0, sampleWidth, sampleHeight);

      const { data } = ctx.getImageData(0, 0, sampleWidth, sampleHeight);
      let luminanceSum = 0;
      let colorVarianceSum = 0;
      let count = 0;

      for (let i = 0; i < data.length; i += 4) {
        const alpha = data[i + 3];
        if (alpha < 20) continue;

        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const luminance = (r + g + b) / 3;

        luminanceSum += luminance;
        colorVarianceSum += (max - min);
        count++;
      }

      if (!count) {
        this.qrAsideLogoIsLight = false;
        return;
      }

      const avgLuminance = luminanceSum / count;
      const avgVariance = colorVarianceSum / count;
      this.qrAsideLogoIsLight = avgLuminance > 185 && avgVariance < 40;
    } catch (e) {
      this.qrAsideLogoIsLight = false;
    }
  };

  img.onerror = () => {
    this.qrAsideLogoIsLight = false;
  };

  img.src = src;
},

async desbloquearAudioProyector() {
  this.audioUnlocked = true;
  this.showAudioUnlockOverlay = false;

  if (!this.player || typeof this.player.playVideo !== 'function') return;

  try {
    this.player.playVideo();
  } catch (e) {
    console.warn("No se pudo forzar play al desbloquear audio:", e);
  }

  this.subirVolumenSuave();
},

    // LÓGICA DE VIDEO Y VOLUMEN
   gestionarSonido(debeEstarMuteado) {
  // Solo actuar si el player está REALMENTE listo
  if (!this.player || typeof this.player.setVolume !== 'function') return;
  
  clearInterval(this.volumeInterval);
  
  if (debeEstarMuteado) {
    this.showAudioUnlockOverlay = false;
    this.player.mute();
  } else {
    if (!this.audioUnlocked) {
      this.showAudioUnlockOverlay = true;
      return;
    }

    // Agregamos un pequeño delay de 300ms para que si hubo un cambio de 
    // pantalla completa, el navegador ya haya terminado de ajustar el CSS.
    setTimeout(() => {
      this.subirVolumenSuave();
    }, 300);
  }
},

 subirVolumenSuave() {
  if (this.volumeInterval) clearInterval(this.volumeInterval);

  // Verificación inicial
  if (!this.player || typeof this.player.setVolume !== 'function') {
    return;
  }

  this.player.unMute();
  let vol = 0;
  this.player.setVolume(vol);

  this.volumeInterval = setInterval(() => {
    // REVISIÓN CRÍTICA: ¿El player sigue existiendo en este paso del ciclo?
    if (!this.player || typeof this.player.setVolume !== 'function') {
      clearInterval(this.volumeInterval);
      return;
    }

    vol += 5;
    if (vol >= 100) {
      this.player.setVolume(100);
      clearInterval(this.volumeInterval);
    } else {
      this.player.setVolume(Math.floor(vol));
    }
  }, 60);
},

bajarVolumenSuave() {
  if (this.volumeInterval) clearInterval(this.volumeInterval);

  if (!this.player || typeof this.player.getVolume !== 'function') return;

  let vol = this.player.getVolume(); 

  this.volumeInterval = setInterval(() => {
    // REVISIÓN CRÍTICA: ¿El player sigue existiendo en este paso del ciclo?
    if (!this.player || typeof this.player.setVolume !== 'function') {
      clearInterval(this.volumeInterval);
      return;
    }

    vol -= 2;
    if (vol <= 0) {
      this.player.setVolume(0);
      this.player.mute();
      clearInterval(this.volumeInterval);
    } else {
      this.player.setVolume(Math.floor(vol));
    }
  }, 100);
},

   escucharCanal() {
  if (this.unsubCanal) this.unsubCanal();
  
  this.unsubCanal = onSnapshot(doc(db, "canales", this.canalId), (snap) => {
    if (snap.exists()) {
      const data = snap.data();
      this.canalConfig = data;

      const activeContextId = data?.contexto_ia?.activeContextId || '';
      const activeContextName = data?.contexto_ia?.activeContextName || data?.contexto_ia?.name || '';
      if (this.proyectorConfig?.activeContextId !== activeContextId || this.proyectorConfig?.activeContextName !== activeContextName) {
        const proyectorRef = doc(db, "proyectores", this.proyectorId);
        updateDoc(proyectorRef, {
          activeContextId,
          activeContextName
        }).catch(e => console.error("Error al sincronizar contexto activo:", e));
      }

      const brandingBloqueadoPorPanelista = this.proyectorConfig?.controlOwnerRole === 'panelista'
        && !!this.proyectorConfig?.hostCanalId
        && this.proyectorConfig.hostCanalId !== this.canalId;

      // Solo sincronizamos el logo del canal al proyector cuando el branding
      // pertenece al canal actual. Si un panelista está usando una pantalla
      // compartida, el contenido cambia de canal pero el marco visual del host
      // debe permanecer intacto.
      if (!brandingBloqueadoPorPanelista && data.logoEmpresa !== this.proyectorConfig?.logoEmpresa) {
        const proyectorRef = doc(db, "proyectores", this.proyectorId);
        updateDoc(proyectorRef, {
          logoEmpresa: data.logoEmpresa || null
        }).catch(e => console.error("Error al sincronizar logoEmpresa:", e));
      }

      // SINCRONIZACIÓN DIRECTA:
      // La TV obedece ciegamente lo que diga el campo en Firestore
      if (data.triggerFullscreen !== undefined) {
        this.youtubeFullscreenActive = data.triggerFullscreen;
      }

      if (this.esYoutube(this.canalConfig.projectionBranding)) {
        this.prepararYoutubeAPI();
      }
      
      if (this.canalConfig.preguntaActivaId && this.canalConfig.preguntaActivaId !== this._lastPreguntaActivaId) {
        this._lastPreguntaActivaId = this.canalConfig.preguntaActivaId;
        this.preguntaCanalId = this.canalConfig.preguntaCanalId || null;
        this.escucharPregunta(this.canalConfig.preguntaActivaId);
      } else if (!this.canalConfig.preguntaActivaId) {
        // Solo resetear el candado: permite que el mismo ID re-dispare escucharPregunta al relanzar.
        // No matar el listener aquí — el proyector es la autoridad sobre qué mostrar,
        // y matar el listener desde el canal rompe preguntas lanzadas por panelistas.
        this._lastPreguntaActivaId = null;
      }
    }
  });
},

escucharVotosCards() {
  if (this.unsubCardVotos) { this.unsubCardVotos(); this.unsubCardVotos = null; }
  if (!this.canalId) return;
  const docRef = doc(db, `canales/${this.canalId}/cards`, 'global');
  this.unsubCardVotos = onSnapshot(docRef, (snap) => {
    this.cardVotos = snap.exists() ? (snap.data().votos || {}) : {};
  });
},

prepararYoutubeAPI() {
  const videoId = this.obtenerYoutubeID(this.canalConfig.projectionBranding);
  
  // 1. Si no hay ID, no hacemos nada
  if (!videoId) return;

  // 2. CORRECCIÓN CRÍTICA (EL CANDADO):
  // Si el videoActualId es el mismo Y el player ya existe Y está funcional, 
  // SALIMOS de la función. No destruimos nada ni reiniciamos. 
  // Esto evita que el video se congele al activar el sonido.
  const el = document.getElementById('youtube-player-proyector');
  const elEsIframe = el && el.tagName === 'IFRAME';

  if (this.videoActualId === videoId && this.player && elEsIframe) {
    return;
  }
  
  // 3. Si llegamos aquí, es porque el video es nuevo o el player no existe
  this.videoActualId = videoId;

  this.$nextTick(() => {
    // Si la API no está cargada, la cargamos
    if (!window.YT || !window.YT.Player) {
      if (!document.getElementById('yt-api-script')) {
        const tag = document.createElement('script');
        tag.id = 'yt-api-script';
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);
        
        // Usamos una función anónima para asegurar que el ID sea el correcto al cargar
        window.onYouTubeIframeAPIReady = () => {
          this.initPlayer(this.videoActualId);
        };
      }
    } else {
      // Si la API ya existe y el video es distinto, inicializamos
      this.initPlayer(videoId);
    }
  });
},

  initPlayer(videoId) {
  if (this.volumeInterval) {
    clearInterval(this.volumeInterval);
    this.volumeInterval = null;
  }

  const el = document.getElementById('youtube-player-proyector');
  if (!el) {
    setTimeout(() => this.initPlayer(videoId), 200);
    return;
  }

  // Si ya hay un player con el mismo video, no lo destruyas, solo asegúrate de que se vea
  if (this.player && typeof this.player.getVideoData === 'function') {
      const currentData = this.player.getVideoData();
      if (currentData && currentData.video_id === videoId) {
          this.player.playVideo();
          return;
      }
  }

  try {
    if (this.player && typeof this.player.destroy === 'function') {
      this.player.destroy();
      this.player = null;
    }
  } catch (e) { console.warn("Error destruyendo player:", e); }

  // Cuando el admin activa el loop-entre-videos, quitamos loop:1 para que
  // ENDED fire limpiamente y podamos avanzar al siguiente video sin rebobine automático
  const loopInterno = !this.canalConfig?.loopVideos;

  this.player = new YT.Player('youtube-player-proyector', {

    height: '100%',
    width: '100%',
    videoId: videoId,
    playerVars: {
      autoplay: 1,
      controls: 0,
      mute: 1,
      ...(loopInterno ? { loop: 1, playlist: videoId } : {}),
      modestbranding: 1,
      rel: 0,
      enablejsapi: 1, // Obligatorio para controlar volumen
      origin: window.location.origin
    },
    events: {
      onReady: (e) => {
        this.youtubeLastState = window.YT?.PlayerState?.UNSTARTED ?? -1;
        this.iniciarVigilanciaYoutube();
        e.target.playVideo();
        if (!this.lastMuteState) this.subirVolumenSuave();
      },
      onStateChange: (e) => {
        this.youtubeLastState = e.data;

        if (e.data === YT.PlayerState.PLAYING) {
          this.detenerVigilanciaYoutube();
          // Resetear guard de señal loop: el próximo ENDED podrá disparar correctamente
          this._loopSignalSent = false;
        } else if (
          e.data === YT.PlayerState.BUFFERING ||
          e.data === YT.PlayerState.UNSTARTED ||
          e.data === YT.PlayerState.CUED
        ) {
          this.iniciarVigilanciaYoutube();
        }

        // Si el video se pausa por alguna razón externa, forzar play (Modo Kiosko)
        if (e.data === YT.PlayerState.PAUSED) {
          this.iniciarVigilanciaYoutube();
          e.target.playVideo();
        }
        if (e.data === YT.PlayerState.ENDED) {
          if (this.canalConfig?.loopVideos) {
            // Modo loop-entre-videos: la TV avanza sola sin depender del admin.
            // Guard: _loopSignalSent evita doble disparo durante destrucción del player.
            if (this._loopSignalSent) return;
            this._loopSignalSent = true;
            this.player.stopVideo();
            this._avanzarLoopLocal();
          } else {
            // Comportamiento por defecto: seguir reproduciendo en loop
            this.iniciarVigilanciaYoutube();
            e.target.playVideo();
          }
        }
      }
    }
  });
},
    iniciarVigilanciaYoutube() {
      this.detenerVigilanciaYoutube();

      if (!this.esYoutube(this.canalConfig?.projectionBranding)) return;

      this.youtubeWatchdogTimer = setTimeout(() => {
        this.relanzarYoutubeSiAtascado();
      }, 10000);
    },
    detenerVigilanciaYoutube() {
      if (this.youtubeWatchdogTimer) {
        clearTimeout(this.youtubeWatchdogTimer);
        this.youtubeWatchdogTimer = null;
      }
    },
    relanzarYoutubeSiAtascado() {
      if (!this.esYoutube(this.canalConfig?.projectionBranding)) return;
      if (!this.player || typeof this.player.getPlayerState !== 'function') return;

      const now = Date.now();
      if (now - this.youtubeLastRecoveryAt < 8000) return;

      try {
        const state = this.player.getPlayerState();
        if (state === window.YT?.PlayerState?.PLAYING) return;

        console.warn("YouTube watchdog: video sin reproducir por 10s, limpiando y relanzando.");
        this.youtubeLastRecoveryAt = now;
        this.limpiarRecursosMedios();

        this.$nextTick(() => {
          setTimeout(() => {
            this.prepararYoutubeAPI();
          }, 250);
        });
      } catch (error) {
        console.warn("YouTube watchdog: no se pudo relanzar el video.", error);
      }
    },
    obtenerYoutubeID(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return (match && match[2].length === 11) ? match[2] : null;
    },

    esYoutube(url) {
      return url && (url.includes('youtube.com') || url.includes('youtu.be'));
    },

    esVideoStorage(url) {
      return url && url.includes('firebasestorage.googleapis.com') && !url.includes('%2Fpresentaciones%2F') && !url.includes('%2Fimagenes%2F');
    },

  escucharPregunta(pId) {
  if (this.unsubPregunta) this.unsubPregunta();

  // Limpiar estado anterior: garantiza pantalla en blanco antes de mostrar nueva pregunta
  this.preguntaActiva = null;
  this.detenerRelojProyector();

  const canal = this.preguntaCanalId || this.canalId;
  const preguntaRef = doc(db, `canales/${canal}/preguntas`, pId);

  this.unsubPregunta = onSnapshot(preguntaRef, (snap) => {

    if (!snap.exists()) {
      this.preguntaActiva = null;
      this.detenerRelojProyector();
      return;
    }

    const data = snap.data();

    // Estado de preparación: no mostrar en pantalla (evita barras antes de arrancar)
    if (data.estado === 'proyectar') {
      this.preguntaActiva = null;
      this.detenerRelojProyector();
      return;
    }

    this.preguntaActiva = {
      id: snap.id,
      ...data
    };

  });

},


// 1. Crear una función que escuche la subcolección de fragmentos
activarListenerVotos(pId) {
  if (this.unsubCounters) this.unsubCounters();

  const canal = this.preguntaCanalId || this.canalId;
  const countersRef = collection(db, `canales/${canal}/preguntas/${pId}/counters`);

  this.unsubCounters = onSnapshot(countersRef, (snap) => {
    let acumuladoVotos = {};
    let totalParticipantes = 0;

    snap.forEach(docu => {
      const shard = docu.data();
      console.log(shard);

      totalParticipantes += (shard.participantes || 0);

      if (shard.votos) {
        Object.entries(shard.votos).forEach(([index, cantidad]) => {
          acumuladoVotos[index] = (acumuladoVotos[index] || 0) + cantidad;
        });
      }
    });

    // 🔥 IMPORTANTE: No toques 'preguntaActiva' directamente para evitar el reset
    this.votosVivos = acumuladoVotos;
    this.participantesVivos = totalParticipantes;
  });
},


desactivarListenerVotos() {

  if (this.unsubCounters) {

    this.unsubCounters();
    this.unsubCounters = null;

  }

},

   getVotos(index) {
  // 1. Si tenemos datos en tiempo real (votosVivos), esa es nuestra prioridad absoluta.
      // Usamos hasOwnProperty para asegurarnos de que el índice existe, aunque sea 0.
      if (this.votosVivos && Object.keys(this.votosVivos).length > 0) {
        return this.votosVivos[index] || 0;
      }

      // 2. Fallback: Si el listener de tiempo real aún no responde, 
      // intentamos sacar el dato del objeto de la pregunta (snapshot inicial).
      if (this.preguntaActiva && this.preguntaActiva.votos) {
        return this.preguntaActiva.votos[index] || 0;
      }

      // 3. Si no hay nada de nada, devolvemos 0
      return 0;
    },

    getPorcentaje(index) {
      const total = this.participantesVivos || this.preguntaActiva?.participantes || 0;
      if (total === 0) return 0;
      const votos = this.getVotos(index);
      return Math.round((votos / total) * 100);
    },

    handleKeydown(e) { if (e.key === 'Escape') this.isSystemFullscreen = false; }
  }
}
</script>

<style scoped>
/* --- BASE & LAYOUT --- */
.web-proyector { 
  display: flex; 
  height: 100vh; 
  background: #080808; 
  color: white; 
  overflow: hidden; 
  position: relative;
  position: absolute;
  
  
}


 .is-fullscreen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
  padding: 0 !important;
  /* Esto obliga a Meet a ignorar cualquier 'safe area' */
  contain: layout size; 
  z-index: 999999;
}

/* --- NUEVOS ESTILOS DINÁMICOS CORREGIDOS --- */

/* Estilo 1: Split estándar */
.layout-style-1 {
  width: min(94vw, 1820px);
  display: flex;
  gap: clamp(24px, 2.4vw, 38px);
  align-items: stretch;
}

.layout-style-1 .branding-media-side,
.layout-style-1 .qr-card-side {
  min-width: 0;
}

.layout-style-1 .branding-media-side {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.layout-style-1 .qr-card-side {
  flex: 0 0 clamp(330px, 25vw, 430px);
  display: flex;
  align-self: flex-start;
  width: clamp(330px, 25vw, 430px);
  height: calc((min(94vw, 1820px) - clamp(330px, 25vw, 430px) - clamp(24px, 2.4vw, 38px)) * 9 / 16);
  max-height: calc(100vh - 230px);
}

.layout-style-1 .qr-glass-card {
  height: 100%;
  padding: clamp(12px, 1.4vw, 22px) clamp(14px, 1.6vw, 24px);
  justify-content: space-between;
  gap: 0;
}

.layout-style-1 .media-wrapper {
  width: 100%;
}

.layout-style-1 .session-branding-footer {
  width: 100% !important;
  margin: 0 !important;
  padding-top: 16px;
}

.layout-style-1 .qr-header h1 {
  font-size: clamp(40px, 4.5vw, 56px);
  margin: 0 0 6px;
  line-height: 1.0;
}

.layout-style-1 .qr-code-stage {
  width: min(100%, clamp(160px, 16vw, 280px));
  margin: 0 auto;
  position: relative;
  left: 0;
}

.layout-style-1 .pin-display {
  padding: 10px 4px 4px;
  margin-top: 0;
  background: transparent;
  border: none;
  border-top: 1.5px solid #e8edf2;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}

.layout-style-1 .pin-value {
  font-size: clamp(34px, 3.8vw, 58px);
}

.layout-style-1 .pin-label {
  order: -1;
  display: block;
  margin-bottom: 0;
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #888;
}

.qr-header-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #000000;
}
.layout-style-1 .qr-header-subtitle {
  font-size: 12px;
  color: #555555;
  margin-bottom: 2px;
}

.layout-style-1 .qr-center-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(8px, 1vw, 14px);
  width: 100%;
}

.layout-style-1 .qr-body {
  padding-top: 0;
  padding-bottom: 0;
  flex: 0 0 auto;
}

.layout-style-1 .qr-steps {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 10px 0;
  border-top: 1.5px solid #f0f0f0;
  border-bottom: 1.5px solid #f0f0f0;
}

.layout-style-1 .qr-step {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: clamp(11px, 1.1vw, 13px);
  color: #333333;
  text-align: left;
  line-height: 1.3;
}

.layout-style-1 .qr-step-num {
  width: 22px;
  height: 22px;
  min-width: 22px;
  background: #111111;
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 900;
}

.layout-style-1 .qr-footer-url {
  font-size: 12px;
  color: #777777;
  margin: 0 0 4px;
  text-align: center;
}

/* ── QR card v2 (layout-style-1) — fully responsive ─────────── */
.layout-style-1 .qr-header-v2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: clamp(3px, 0.4vw, 6px);
}
.layout-style-1 .qr-title-v2 {
  font-size: clamp(18px, 2.1vw, 46px);
  line-height: 1.05;
  margin: 0;
  text-align: center;
  text-transform: uppercase;
  color: #111;
}
.layout-style-1 .qr-title-accent {
  display: block;
  color: #111;
}
.layout-style-1 .qr-subtitle-v2 {
  font-size: clamp(10px, 0.85vw, 13px);
  color: #666;
  margin: 0;
  text-align: center;
  line-height: 1.4;
}

/* horizontal steps */
.layout-style-1 .qr-steps-h {
  display: flex;
  justify-content: space-between;
  gap: clamp(4px, 0.5vw, 8px);
  padding: 0;
}
.layout-style-1 .qr-step-h {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(4px, 0.5vw, 7px);
  font-size: clamp(10px, 0.85vw, 12px);
  font-weight: 600;
  color: #aaa;
  text-align: center;
  line-height: 1.3;
}
.layout-style-1 .qr-step-h-icon {
  width: clamp(28px, 2.6vw, 36px);
  height: clamp(28px, 2.6vw, 36px);
  min-width: clamp(28px, 2.6vw, 36px);
  border-radius: 50%;
  border: 1.5px solid #ccc;
  color: #bbb;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* footer v2 */
.layout-style-1 .qr-footer-v2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  padding-top: 0;
  margin-top: 0;
}
.layout-style-1 .qr-code-session-label {
  font-size: clamp(9px, 0.8vw, 11px);
  color: #777;
  font-weight: 500;
  margin: 0;
  text-align: center;
}
.layout-style-1 .qr-code-session-value {
  font-size: clamp(34px, 3.8vw, 58px);
  font-weight: 900;
  letter-spacing: 0.18em;
  color: #111;
  margin: 0;
  line-height: 1.1;
}

.qr-footer-subtitle {
      font-size: 14px;
    line-height: 1.45;
    color: #6b7280;
    text-align: center;
    width: 70%;
    margin: auto;
    margin-bottom: 40px;
}



.fade-qr-enter-active,
.fade-qr-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-qr-enter-from {
  opacity: 0;
  transform: translateY(20px) scale(0.98);
}

.fade-qr-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.fade-qr-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.fade-qr-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(0.98);
}

/* Estilo 2: Solo Video Centrado */
.layout-style-2 { justify-content: center !important; }
.layout-style-2 .branding-media-side { flex: none; width: auto; max-width: none; }
.layout-style-2 .qr-card-side { display: none !important; }
.layout-style-2 .media-wrapper {
  width: min(92vw, calc((100vh - 210px) * 16 / 9));
  aspect-ratio: 16/9;
  margin: auto;
  max-height: calc(100vh - 210px);
}

/* Estilo 3: QR Flotante con Altura Fija y Centrado Vertical */
.layout-style-3 { 
  width: 100% !important; 
  max-width: none !important; 
  height: 100vh; 
  position: relative; 
  gap: 0 !important; 
  margin: 0 !important;
  /* IMPORTANTE: Fondo transparente para que el video "perfore" la capa negra */
  background: transparent !important; 
  overflow: hidden;
  display: block !important;
}

.layout-style-3 .branding-media-side { 
  position: absolute; 
  inset: 0; 
  width: 100%; 
  height: 100%; 
  z-index: 1; /* Al fondo */
  background: transparent !important;
}

.layout-style-3 .media-wrapper { 
  width: 100vw; 
  height: 100vh; 
  border-radius: 0; 
  box-shadow: none; 
  background: transparent !important;
}

/* Forzamos que el reproductor de YouTube no herede opacidades */
.layout-style-3 .video-fixed-container,
.layout-style-3 #youtube-player-proyector {
  width: 100% !important;
  height: 100% !important;
  background: black; /* El reproductor sí debe tener su fondo */
}

.layout-style-3 .qr-card-side { 
  position: absolute; 
  top: 0;
  right: 0;
  width: min(28vw, 430px);
  min-width: 340px;
  height: 100vh;
  z-index: 10;
  flex: none;
  display: flex;
}

.layout-style-3 .qr-glass-card { 
  height: 100%; 
  width: 100%;
  background: rgba(255, 255, 255, 1); 
  box-shadow: -18px 0 38px rgba(0, 0, 0, 0.28);
  border: none;
  border-radius: 0;
  padding: 26px 22px 22px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* --- HEADER SUPERIOR --- */
.room-header {
  position: fixed;
  top: 0; 
  left: 0; 
  right: 0; 
  /* ELIMINAR: width: 100% */
  padding: 30px 60px;
  box-sizing: border-box; /* ← AÑADIR esto */
  z-index: 100;
  background: linear-gradient(to bottom, rgba(8,8,8,0.9), transparent);
}


.header-left { display: flex; align-items: center; gap: 20px; }
.header-logo { height: 35px; }
.header-divider { width: 1px; height: 30px; background: rgba(255,255,255,0.1); }
.live-status { font-size: 14px; font-weight: 800; color: #ef4444; letter-spacing: 2px; display: flex; align-items: center; gap: 8px; }
.pulse-dot-red { width: 8px; height: 8px; background: #ef4444; border-radius: 50%; animation: pulse-red 1.5s infinite; }
.header-right { text-align: right; }
.room-label { font-size: 12px; color: #64748b; font-weight: 800; display: block; letter-spacing: 1px; }
.room-name { font-size: 24px; color: white; text-transform: uppercase; }

/* --- BRANDING BACKGROUND --- */
.branding-background { position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 1; }
.logo-infinity-overlay { position: absolute; top: -10%; left: 50%; transform: translateX(-50%) rotateX(45deg); width: 120%; opacity: 0.15; }
.infinity-logo { width: 100%; mask-image: linear-gradient(to bottom, white 0%, transparent 80%); -webkit-mask-image: linear-gradient(to bottom, white 0%, transparent 80%); }
.bottom-gradient-mask { position: absolute; bottom: 0; left: 0; width: 100%; height: 60%; background: linear-gradient(to top, #080808 20%, transparent 100%); }
.content-over { position: relative; z-index: 5; }

/* --- WELCOME SCREEN (PAIRING) --- */
.welcome-screen { width: 100%; /* era 100vw */ height: 100%; /* era 100vh */ display: flex; flex-direction: column; align-items: center; justify-content: center; position: relative; z-index: 10; }
.main-logo-landing { width: 220px; margin-bottom: 60px; filter: drop-shadow(0 10px 30px rgba(0,0,0,0.5)); }
.btn-user-desktop-entry {
  margin: 20px auto 22px;
  min-height: 36px;
  padding: 0 16px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #d8ff34 0%, #b9f31c 100%);
  color: #141810;
  font-size: 13px;
  font-weight: 800;
  box-shadow: 0 18px 34px rgba(126,154,20,0.25);
  cursor: pointer;
  position: fixed;
  right: 3%;
  top: 2%;
  z-index: 20;
}
.pairing-container h1 { font-size: 38px; letter-spacing: -1px; }
.subtitle { color: #888; margin-bottom: 40px; font-size: 19px; }
.qr-pairing-wrapper { max-width: 640px; background: white; padding: 40px; border-radius: 40px; display: flex; align-items: center; gap: 40px; box-shadow: 0 40px 100px rgba(0,0,0,0.6); }
.pin-info { text-align: left; color: #1a1a1a; border-left: 2px solid #f0f0f0; padding-left: 40px; }
.pin-info h2 { font-size: 72px; font-weight: 900; letter-spacing: -3px; line-height: 1; }

/* --- PROJECTION AREA --- */
.projection-area { flex: 1; display: flex; align-items: center; justify-content: center; position: relative; z-index: 10; padding-top: 100px; }

/* --- DISEÑO DIVIDIDO (SIN MEDIA) --- */
.qr-full-split-layout { display: flex; width: 90%; max-width: 1600px; margin: auto; gap: 80px; align-items: center; justify-content: center; height: 80vh; }
.instructions-side { flex: 1; text-align: left; height: 40vh; display: flex; flex-direction: column; justify-content: space-around; }
.instructions-title { font-size: clamp(35px, 4vw, 60px); margin-bottom: 40px; background: linear-gradient(90deg, #ffffff, #94a3b8); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
.steps-container { display: flex; flex-direction: column; gap: 30px; }
.step-item { display: flex; align-items: center; gap: 25px; }
.step-number { width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; font-weight: 900; color: white; box-shadow: 0 10px 20px rgba(0,0,0,0.3); }
.step-text h3 { font-size: 28px; margin: 0; color: #fff; }
.step-text p { font-size: 18px; color: #94a3b8; margin: 5px 0 0 0; }
.qr-access-side { flex: 1; display: flex; justify-content: center; }

/* =============================================
   DISEÑO QR PREMIUM (HORIZONTAL ELÁSTICO)
   ============================================= */

.qr-tv-premium-layout {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  /* Padding dinámico para que el contenido no toque los bordes */

}

.tv-background-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-blend-mode: screen;
  inset: 0;
  background-repeat: no-repeat;
  will-change: background-position, opacity;
  transition: all 0.8s ease;

}

.tv-background-layer::after {
  content: "";
  position: absolute;
  inset: 0;
  background: inherit;
  filter: blur(80px);
  opacity: 0.5;
  z-index: 0;
}

.tv-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tv-bg-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.4) 100%),
              linear-gradient(90deg, rgba(0,0,0,0.9) 10%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.8) 100%);
}

/* --- GRID DE CONTENIDO (Mantenemos el Grid pero con columnas flexibles) --- */
.tv-content-grid {
  display: grid;
  /* La columna del QR (0.8fr) ahora tiene un mínimo y un máximo real */
  grid-template-columns: 1.3fr minmax(300px, 0.7fr);
  /* El gap se reduce automáticamente en pantallas pequeñas */
  gap: clamp(30px, 6vw, 100px);
  width: 85%;
  max-width: 1800px;
  align-items: center;
  z-index: 10;
  transform: rotate(0deg);
}

/* --- INFORMACIÓN (IZQUIERDA) --- */
.tv-info-side {
  text-align: left;
  color: white;
}

.tv-badge {
  display: inline-block;
  padding: 8px 20px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 25px;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.05);
}

.tv-class-title {
  font-size: clamp(30px, 4.5vw, 80px);
  line-height: 1.1;
  margin-bottom: 25px;
}

.highlight-text {
  color: #ffffff;
  opacity: 0.9;
  font-weight: 300;
}

.poppins-bold { font-weight: 800; }

.tv-class-description {
  /* Tamaño de fuente más fluido */
  font-size: clamp(16px, 1.3vw, 22px);
  color: #ffffff;
  max-width: 600px;
  line-height: 1.5;
  margin-bottom: 35px;
}

.tv-host-info {
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: clamp(14px, 1.1vw, 18px);
  color: #94a3b8;
}

.host-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  box-shadow: 0 0 15px currentColor;
  color: white;

}

/* --- QR CARD (DERECHA - ELÁSTICA) --- */
.tv-qr-floating-card {
  background: white;
  border-radius: 40px;
  /* Padding interno también elástico */
  padding: clamp(20px, 3vw, 40px);
  width: 100%;
  /* No permitimos que crezca infinito pero sí que se encoja */
  max-width: 500px; 
  box-shadow: 0 50px 100px rgba(0,0,0,0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
  transform: rotate(0deg);
}

.tv-qr-container {
  width: 100%;
  background: #f8fafc;
  border-radius: 30px;
  padding: clamp(10px, 1.5vw, 20px);
  margin-bottom: clamp(15px, 2vw, 30px);
}

.qr-img-pro {
  width: 100%;
  height: auto;
  display: block;
}

.tv-pin-huge {
  /* El PIN ahora nunca romperá la card porque su tamaño es elástico */
  font-size: clamp(40px, 5.5vw, 90px);
  font-weight: 900;
  color: #0f172a;
  letter-spacing: clamp(2px, 0.5vw, 8px);
  margin: 5px 0;
  line-height: 1;
}

.tv-code-hint {
  font-size: clamp(10px, 1vw, 14px);
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 4px;
}

.tv-instruction-label {
  font-size: clamp(14px, 1.2vw, 18px);
  color: #64748b;
}

@media screen and (max-width: 1500px){
 .tv-qr-container{
  width: 300px;
  
 }

 .tv-content-grid{
  width: 80%;

  transform: rotate(0deg);
 
 }

 .tv-info-side{
  
 }

 .tv-qr-floating-card {
  width: 70%;
  
  
  transform: rotate(0deg);
  
  
 }
 

}

/* Solo bajamos a vertical en móviles o pantallas REALMENTE pequeñas (móviles) */
@media (max-width: 800px) {
  .tv-content-grid {
    grid-template-columns: 1fr;
    text-align: center;
  }
  .tv-info-side { display: flex; flex-direction: column; align-items: center; }
  .tv-qr-floating-card { transform: rotate(0deg); max-width: 350px; }
}

/* --- CARDS & QR --- */
.qr-glass-card {
  background: #ffffff;
  border-radius: 45px;
  padding: clamp(24px, 2vw, 30px);
  display: flex;
  flex-direction: column;
  justify-content: space-between; 
  width: 100%;
  box-shadow: 0 40px 100px rgba(0, 0, 0, 0.4);
  color: #1a1a1a;
  text-align: center;
  height: 100%;
}

.qr-body { flex: 1; display: flex; align-items: center; justify-content: center; width: 100%; }
.qr-code-stage {
  position: relative;
  width: min(100%, 460px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-code-stage-aside {
  width: 100%;
  max-width: 320px;
}

.qr-code-stage-tv {
  width: 100%;
}

.qr-logo-core {
  position: absolute;
  width: clamp(52px, 14%, 74px);
  height: clamp(52px, 14%, 74px);
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 28px rgba(0,0,0,0.16);
  overflow: hidden;
}

.qr-logo-core.is-dark-shell {
  background: #111111;
}

.qr-logo-core img {
  width: 66%;
  height: 66%;
  object-fit: contain;
}

.qr-logo-core.is-dark-shell img {
  filter: none;
}

.qr-logo-core-tv {
  width: clamp(50px, 13%, 72px);
  height: clamp(50px, 13%, 72px);
}

.pin-huge-display-tv { margin-top: 30px; padding-top: 30px; border-top: 2px solid #f1f5f9; }
.pin-huge-display-tv .pin-v { font-size: 85px; color: #0f172a; letter-spacing: 5px; margin: 10px 0; font-weight: 900; }
.web-url-hint { color: #64748b; font-size: 20px; }



/* --- QR & BRANDING CON VIDEO --- */
.qr-branding-container {
  display: flex;
  width: 92%;
  max-width: 1920px;
  margin: auto;
  gap: 30px;
  align-items: stretch; 
  justify-content: center;
}
.branding-media-side { flex: 1.8; display: flex; flex-direction: column; }
.media-wrapper {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 45px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 30px 60px rgba(0,0,0,0.7);
  position: relative;
}

/* --- VIDEO FIXED / MODO CINE --- */
.video-fixed-container {
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}
.yt-controls-block {
  position: absolute;
  inset: 0;
  z-index: 2;
  background: transparent;
  pointer-events: all;
}

.video-fixed-container.modo-cine {
  position: fixed !important;
  margin: auto;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  max-width: none !important; 
  max-height: none !important;
  transform: none !important; 
  z-index: 999999 !important;
  background: #000;
}

.video-fixed-container iframe, 
#youtube-player-proyector {
  width: 100% !important;
  height: 100% !important;
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  border: none;
}

.branding-video, .branding-image { width: 100%; height: 100%; object-fit: cover; }
.session-branding-footer { width: 93%; margin: auto; margin-top: 20px;  padding: 25px 0 0 5px; text-align: left;  max-width: 1920px;  }
.session-branding-footer-centered {
  width: 100%;
  text-align: center;
  font-size: clamp(18px, 1.5vw, 24px);
  color: rgba(255,255,255,0.92);
  margin: 0;
  padding-top: 8px;
}
@media screen and (max-width: 1899px){
  .session-branding-footer {
    width: 60%;
    margin: 0;
    margin-top: -4%;
    left: 0;
    max-width: 1920px;
    text-align: left;
    
  }

  .layout-style-1 .qr-glass-card,
  .layout-style-3 .qr-glass-card{
    width: 100%;
  }

  .layout-style-1 .branding-media-side{
    width: auto;
  }
}

@media screen and (max-width: 1400px){
  
  .layout-style-1 .qr-glass-card,
  .layout-style-3 .qr-glass-card{
    width: 100%;
  }

  .session-branding-footer{
    margin-top: 0%;
  }

  .layout-style-1 .qr-body{
    width: 100%;
    margin-left: 0;
  }
}
.session-branding-footer h2 { font-size: clamp(28px, 3.2vw, 50px); font-weight: 800; margin: 0; }
.qr-card-side { flex: 0 0 450px; display: flex; }
.qr-header h1 { font-size: clamp(28px, 2vw, 32px); font-weight: 800; margin: 10px 0; }
.live-tag { background: #000000; color: white; padding: 4px 12px; border-radius: 6px; font-size: 12px; font-weight: 900; }
.pin-display { background: #f8fafc; padding: 20px; border-radius: 25px; margin-top: 20px; border: 1px solid #e2e8f0; }
.pin-label { font-size: 12px; color: #64748b; font-weight: 800; }
.pin-value { font-size: clamp(48px, 4vw, 60px); font-weight: 900; letter-spacing: 4px; color: #0f172a; }
.qr-responsive { width: 100% !important; height: auto !important; max-width: 100%; object-fit: contain; display: block; }

.qr-aside-shell {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
}

.qr-aside-top {
  text-align: left;
}

.qr-aside-brand {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.qr-aside-brand img {
  width: min(240px, 82%);
  max-height: 82px;
  object-fit: contain;
  display: block;
}

.qr-aside-brand img.is-light {
  filter: brightness(0);
}

.qr-aside-top h1 {
  font-size: clamp(26px, 1.6vw, 34px);
  color: #111827;
  line-height: 1.02;
  margin: 14px 0 2px;
}

.qr-body-aside {
  padding: 0;
  flex: none;
}

.qr-aside-points {
  display: block;
}

.qr-aside-point {
  all: unset;
}

.qr-aside-points p {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: #64748b;
  text-align: center;
}

.qr-footer-aside {
  margin-top: auto;
}

.pin-display-aside {
  margin-top: 0;
  text-align: center;
  padding: 14px 16px 10px;
  background: transparent;
  border: none;
  border-radius: 0;

}

.layout-style-3 .qr-code-stage-aside {
  max-width: 258px;
  margin: 8px auto 6px;
}

.layout-style-3 .qr-responsive {
  width: 100% !important;
}

.layout-style-3 .qr-body {
  padding-top: 6px;
  padding-bottom: 6px;
  min-height: 0;
}

.layout-style-3 .pin-value {
  font-size: clamp(42px, 3.4vw, 56px);
  letter-spacing: 2px;
}

.layout-style-3 .pin-label {
  font-size: 11px;
  letter-spacing: 0.08em;
}

.layout-style-3 .qr-aside-points {
  margin-top: 2px;
}

.layout-style-3 .qr-aside-points p {
  font-size: 12px;
  line-height: 1.52;
  color: #6b7280;
  max-width: 290px;
  margin-left: auto;
  margin-right: auto;
}

.layout-style-3 .qr-glass-card .live-tag {
  align-self: flex-start;
}

.layout-style-3 .qr-aside-top,
.layout-style-3 .pin-display-aside,
.layout-style-3 .qr-aside-points {
  text-align: center;
}

@media screen and (max-width: 1600px) {
  .layout-style-1 {
    grid-template-columns: minmax(0, 1.12fr) minmax(320px, 0.88fr);
  }

  .layout-style-3 .qr-card-side {
    width: min(30vw, 400px);
    min-width: 320px;
  }
}

/* --- RESULTADOS & BARRAS --- */
.results-layout { width: 90%; max-width: 1600px; margin: auto; display: flex; flex-direction: column; align-items: center; }
.display-question { font-size: 45px; font-weight: 800; margin-bottom: 60px; text-align: center; text-shadow: none !important; transition: all 0.5s ease; }
.charts-container { display: flex; align-items: flex-end; justify-content: center; gap: 30px; height: 50vh; width: 100%; }

.bar-group { flex: 1; display: flex; flex-direction: column; align-items: center; height: 100%; max-width: 180px; min-width: 120px; justify-content: flex-end; }
.bar-wrapper { width: 100%; min-height: 42vh; flex: 1; background: rgba(255,255,255,0.05); border-radius: 40px 40px 15px 15px; position: relative; overflow: hidden; display: flex; flex-direction: column; justify-content: flex-end; border: 1px solid rgba(255,255,255,0.1); }
.bar-fill { width: 100%; transition: height 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
.bar-value { top: 26%; width: 100%; text-align: center; font-size: 32px; font-weight: 900; }
.bar-label { margin-top: 20px; font-size: 18px; font-weight: 600; color: #ffffff; text-align: center; min-height: 40px; display: flex; align-items: center; justify-content: center; }
.option-indicator { 
      width: 50px;
    height: 50px;
    background: #ffffff4d;
    color: #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 900;
    margin-top: 20px;
    /* box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3); */
    flex-shrink: 0;
}

/* --- ANIMACIONES & SPLASH --- */
.splash-screen { position: fixed; top: 0; left: 0; width: 100%; /* era 100vw */
  height: 100%; /* era 100vh */ background: #080808; display: flex; align-items: center; justify-content: center; z-index: 10000; }
.splash-logo { width: 250px; animation: pulse-logo 2s infinite; }

@keyframes pulse-logo { 0%, 100% { transform: scale(1); opacity: 0.8; } 50% { transform: scale(1.05); opacity: 1; } }
@keyframes pulse-red { 0% { transform: scale(1); opacity: 1; } 100% { transform: scale(2); opacity: 0; } }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: none; } }
.animate-in { animation: fadeInUp 0.8s ease-out; }
.fade-enter-active, .fade-leave-active { transition: opacity 0.8s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

/* --- BOTONES DE CONTROL --- */
.exit-fs-btn { position: absolute; top: 30px; right: 30px; background: rgba(0,0,0,0.5); backdrop-filter: blur(10px); color: white; border: 1px solid rgba(255,255,255,0.1); padding: 12px 24px; border-radius: 50px; cursor: pointer; opacity: 0; transition: 0.3s; z-index: 1000000; }
.exit-fs-btn.show { opacity: 1; }
/* Contenedor que detecta el hover desde el borde superior */
.control-drawer-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  display: flex;
  justify-content: center;
  /* El contenedor empieza un poco afuera */
  transform: translateY(-85%); 
  transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}

/* Al pasar el mouse, baja completamente */
.control-drawer-wrapper:hover {
  transform: translateY(0);
}

.control-drawer-content {
  background: rgba(15, 15, 15, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-top: none;
  border-radius: 0 0 20px 20px;
  padding: 15px 30px 25px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 40px rgba(0,0,0,0.5);
}

.audio-unlock-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000001;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(8, 8, 8, 0.48);
  backdrop-filter: blur(24px);
}

.audio-unlock-card {
      width: min(92vw, 560px);
    padding: 34px 34px 30px;
    border-radius: 34px;
    /* background: rgba(255, 255, 255, 0.1); */
    /* border: 1px solid rgba(255, 255, 255, 0.14); */
    /* box-shadow: 0 24px 80px rgba(0, 0, 0, 0.35); */
    text-align: center;
    color: #ffffff;
}

.audio-unlock-kicker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(255,255,255,0.12);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  margin-bottom: 18px;
}

.audio-unlock-card h2 {
  font-size: clamp(36px, 3vw, 48px);
  line-height: 1.02;
  margin: 0 0 12px;
      text-transform: uppercase;
}

.audio-unlock-card p {
  margin: 0 auto 24px;
  max-width: 420px;
  font-size: 14px;
  line-height: 1.55;
  color: rgba(255,255,255,0.86);
}

.audio-unlock-btn {
      border: 1px solid #ffffff;
    background: #ffffff38;
    color: #ffffff;
    border-radius: 999px;
    padding: 16px 28px;
    min-width: 220px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    margin-top: 10%;
    transition: transform 0.18s ease, box-shadow 0.18s ease;
    box-shadow: 0 12px 28px rgba(255, 255, 255, 0.16);
}

.audio-unlock-btn:active {
  transform: scale(0.98);
}

.buttons-container {
  display: flex;
  gap: 15px;
  align-items: center;
}

/* El "tirador" pequeño que asoma abajo */
.drawer-handle {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.handle-icon {
  width: 30px;
  height: 3px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

/* Estilos de botones mejorados */
.fs-toggle {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 12px;
  padding: 8px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: 0.2s;
}

.fs-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

.fs-toggle.secondary {
  background: white;
  color: black;
  font-weight: bold;
}

.fs-toggle p {
  margin: 0;
  font-size: 13px;
}
.minimal-footer { position: fixed; margin: auto; bottom: 4%; left: 0; right: 0; text-align: center; font-size: 12px; opacity: 0.45; color: #fff; }
.minimal-footer-link { color: inherit; text-decoration: none; opacity: 1; }
.minimal-footer-link:hover { text-decoration: underline; }

/* --- PDF & IMAGES --- */
.pdf-container { position: relative; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; background: #000; overflow: hidden; border-radius: 12px; }
#pdf-canvas { 
   
 max-width: 100%; max-height: 100%; object-fit: contain; }

.pdf-projection-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  overflow: visible;
}

.pdf-canvas-bg {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-sizing: border-box;
  overflow: visible;
}

.pdf-shadow-effect {
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28), 0 0 0 1px rgba(0, 0, 0, 0.1);
}

 /* =========================================
   2. FIX PARA IMÁGENES (Pantalla Completa y Normal)
   ========================================= */
.image-projection-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  overflow: hidden;
}

.branding-image-full {
  width: 100%;
  height: 100%;
  object-fit: contain; /* Usa todo el espacio manteniendo proporción */
}

/* Clase que se activa cuando youtubeFullscreenActive es true */
.image-projection-wrapper.fullscreen-mode {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 999999 !important;
  background: #000000 !important;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
}

.image-projection-wrapper.fullscreen-mode .branding-image-full {
  width: 100vw !important;
  height: 100vh !important;
  max-width: none !important;
  max-height: none !important;
  object-fit: contain !important; /* Se asegura de que la imagen no se recorte en pantalla gigante */
}

/* --- 1. CONTENEDOR DEL PDF EN PANTALLA COMPLETA --- */
.pdf-projection-wrapper.pdf-fullscreen-mode {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 999999 !important;
  
  /* Fondo gris claro/azulado estilo Word/Acrobat */
  background: #eef2f5 !important; 
  
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  
  /* Un poco de padding para que la hoja no pegue contra los bordes del monitor */
  padding: 0 !important; 
  box-sizing: border-box !important;
  margin: 0 !important;
}

.pdf-projection-wrapper.pdf-fullscreen-mode .pdf-canvas-bg {
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  box-sizing: border-box !important;
}

/* --- 2. EL EFECTO DE "HOJA DE PAPEL" PARA EL CANVAS --- */
.pdf-projection-wrapper.pdf-fullscreen-mode canvas {
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  /* La magia: se adapta horizontal o verticalmente sin estirarse */
  object-fit: contain !important; 
  background-color: white !important;
  border-radius: 0 !important;
  box-shadow: none !important; 
}

.pdf-projection-wrapper.pdf-fullscreen-mode.pdf-portrait {
  background: #eef2f5 !important;
}

.pdf-projection-wrapper.pdf-fullscreen-mode.pdf-portrait .pdf-canvas-bg {
  padding: 32px !important;
  box-sizing: border-box !important;
}

.pdf-projection-wrapper.pdf-fullscreen-mode.pdf-portrait canvas {
  width: auto !important;
  height: auto !important;
  max-width: calc(100vw - 64px) !important;
  max-height: calc(100vh - 64px) !important;
  border-radius: 6px !important;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28), 0 0 0 1px rgba(0, 0, 0, 0.1) !important;
}

/* Contenedor principal para centrado total */
.comentario-destacado-container {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 40px;
}

/* La Card Blanca Minimalista */
.comentario-card-proyector {
  background: white;
  width: 100%;
  max-width: 800px;
  border-radius: 30px;
  padding: 50px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  position: relative;
  text-align: left;
}

.comentario-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
}

.autor-foto img, .autor-inicial {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}

.autor-inicial {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: bold;
  color: white;
  text-transform: uppercase;
}

.autor-info-proyector h3 {
  color: #1a1a1a;
  font-size: 28px;
  margin: 0;
  font-family: 'Poppins', sans-serif;
}

.voto-tag {
  color: #666;
  font-size: 18px;
}

.comentario-body p {
  color: #000;
  font-size: 38px; /* Texto grande para impacto */
  line-height: 1.3;
  font-weight: 500;
  margin: 0;
  font-style: italic;
}

.comentario-footer-logo {
  position: absolute;
  bottom: 25px;
  right: 40px;
  opacity: 0.3;
}

.comentario-footer-logo img {
  width: 80px;
}

/* Transiciones (Entrada y Salida) */
.comment-pop-enter-active {
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.comment-pop-leave-active {
  transition: all 0.3s ease-in;
}

.comment-pop-enter-from {
  opacity: 0;
  transform: scale(0.8) translateY(30px);
}

.comment-pop-leave-to {
  opacity: 0;
  transform: scale(1.1) translateY(-20px);
}


@keyframes card-spread {
  0% {
    transform: scale(0.05);
    opacity: 0;
  }
  65% {
    opacity: 1;
  }
  85% {
    transform: scale(1.04);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.cards-projector-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 36px 56px 28px;
  gap: 24px;
  overflow: hidden;
  box-sizing: border-box;
}

.cards-proj-label {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  max-width: 90%;
  flex-shrink: 0;
  letter-spacing: -0.3px;
  margin: 0;
}

.cards-proj-grid {
  display: grid;
  grid-template-columns: repeat(4, auto);
  gap: 18px;
  justify-content: center;
  align-content: center;
}

.cards-proj-item {
  position: relative;
  border-radius: 26px;
  overflow: hidden;
  aspect-ratio: 2 / 3;
  animation: card-spread 0.65s cubic-bezier(0.34, 1.3, 0.64, 1) both;
  box-shadow: 0 14px 40px rgba(0,0,0,0.6);
}

.cards-proj-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cards-proj-color-bg {
  position: absolute;
  inset: 0;
}

.cards-proj-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(0deg, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.1) 55%, transparent 100%);
}

.cards-proj-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 14px 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cards-proj-text {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  line-height: 1.3;
  text-shadow: 0 1px 4px rgba(0,0,0,0.5);
}

.cards-proj-vote-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 110px;
  height: 110px;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 2px solid rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0px;
}

.cards-proj-vote-count {
  font-size: 40px;
  font-weight: 800;
  color: #fff;
  line-height: 1;
  animation: vote-pop 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes vote-pop {
  from { transform: scale(0.5); opacity: 0; }
  to   { transform: scale(1);   opacity: 1; }
}

.cards-proj-vote-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.sort-results-container {
  width: 100%;
  min-height: 60vh;
  display: flex;
  align-items: center;
}

.sort-ranking-grid {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  max-width: 1100px;
  margin: 20px auto;
}

.ranking-item {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  padding: 20px 35px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  gap: 24px;
}

.ranking-number {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 26px;
  flex-shrink: 0;
}

.ranking-content {
  flex: 1;
}

.ranking-text {
  display: block;
  font-size: 28px;
  margin-bottom: 10px;
  text-align: left;
}

.ranking-bar-bg {
  width: 100%;
  height: 18px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 9px;
  overflow: hidden;
}

.ranking-bar-fill {
  height: 100%;
  border-radius: 9px;
  transition: width 1s cubic-bezier(0.17, 0.67, 0.83, 0.67);
}



.ranking-pct {
  font-size: 28px;
}

.ranking-main-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 6px;
}

.favorito-tag {
  font-size: 0.85rem;
  background: rgba(255, 215, 0, 0.15);
  color: #FFD700;
  padding: 2px 12px;
  border-radius: 20px;
  border: 1px solid rgba(255, 215, 0, 0.3);
  font-weight: 500;
  animation: shine 2s infinite;
}

.ranking-stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 80px;
}

.points-label {
  font-size: 10px;
  text-transform: uppercase;
  opacity: 0.5;
  margin-top: -4px;
}

/* Animación de brillo para el favorito */
@keyframes shine {
  0% { opacity: 0.8; }
  50% { opacity: 1; box-shadow: 0 0 10px rgba(255, 215, 0, 0.2); }
  100% { opacity: 0.8; }
}





/* Estilos saludos */
.greetings-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* No interfiere con clics */
  z-index: 50;
  overflow: hidden;
}

.greeting-card-float {
  position: absolute;
  bottom: -150px; /* Empieza fuera por abajo */
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 12px 20px;
  border-radius: 60px; /* Estilo píldora */
  display: flex;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  min-width: 250px;
  max-width: 400px;
  /* Animación principal */
  animation: floatUp linear forwards;

  transition: all 0.3s ease;
  animation-timing-function: ease-in-out;
  will-change: transform, bottom; /* Optimización para Smart TVs */
}

.g-card-content {
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;
}

.g-text-wrapper{
  text-align: left;
  max-width: 300px;
}

.g-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--brand-color, #6366f1);
}

.g-name {
  display: block;
  font-weight: 800;
  color: #1a1a1a;
  font-size: 14px;
}

.g-text {
  margin: 0;
  color: #444;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* KEYFRAMES DE MOVIMIENTO */
@keyframes floatUp {
  0% {
    bottom: -100px;
    opacity: 0;
  }
  15% {
    opacity: 1;
  }
  

  50%{
    bottom: 50vh;

  }
  /* Mantenemos la opacidad alta durante la mayor parte del trayecto central */
  85% {
    opacity: 1;
     bottom: 80vh;
  }
  100% {
    bottom: 110vh; /* Sube por encima de la pantalla */
    opacity: 0;
  }
}

/* Transición de Vue para suavizar la entrada/salida del DOM */
.greeting-float-enter-active {
  transition: all 0.5s ease;
}
.greeting-float-enter-from {
  opacity: 0;
  transform: scale(0.8);
}


.live-reactions-container {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
}

@keyframes emojiFlyUp {
  0% {
    transform: translateY(0) translateX(0) scale(0.5);
    opacity: 0;
  }
  /* Aparece rápido pero sin detener el movimiento */
  15% {
    opacity: 1;
    transform: translateY(-15vh) translateX(15px) scale(1.2);
  }
  /* Desvanecimiento gradual mientras sigue subiendo */
  80% {
    opacity: 1;
  }
  100% {
    /* Sube hasta desaparecer del todo */
    transform: translateY(-80vh) translateX(-15px) scale(1);
    opacity: 0;
  }
}

.floating-emoji {
  position: absolute;
  bottom: 20px;
  pointer-events: none;
  z-index: 9999;
  /* 'linear' hace que no acelere ni frene, 'infinite' no, porque el JS lo remueve */
  animation: emojiFlyUp 2.5s linear forwards; 
  /* Evita saltos visuales en pantallas de alta tasa de refresco */
  will-change: transform, opacity;
}


.tv-qr-side {
  /* Establecemos el tiempo de la transición (0.8 segundos para que sea muy suave) */
  transition: opacity 0.8s cubic-bezier(0.4, 0, 0.2, 1), 
              transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateY(0);
}

/* El estado cuando el QR está apagado */
.tv-qr-side.is-hidden {
  opacity: 0;
  /* Opcional: un ligero movimiento hacia abajo para que se sienta más fluido */
  transform: translateY(20px); 
  pointer-events: none; /* Evita que el QR invisible reciba clics */
}




.tv-info-side {
  /* Establecemos el tiempo de la transición (0.8 segundos para que sea muy suave) */
  transition: opacity 0.8s cubic-bezier(0.4, 0, 0.2, 1), 
              transform 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;
  transform: translateY(0);
}

/* El estado cuando el QR está apagado */
.tv-info-side.is-hidden {
  opacity: 0;
  /* Opcional: un ligero movimiento hacia abajo para que se sienta más fluido */
  transform: translateY(20px); 
  pointer-events: none; /* Evita que el QR invisible reciba clics */
}


.fade-bg-enter-active,
.fade-bg-leave-active {
  transition: opacity 2s ease;
  position: absolute;
  inset: 0;
}

.fade-bg-enter-from {
  opacity: 0;
}

.fade-bg-enter-to {
  opacity: 1;
}

.fade-bg-leave-from {
  opacity: 1;
}

.fade-bg-leave-to {
  opacity: 0;
}



.countdown-fullscreen {
    position: fixed;
  top: 0; left: 0;
  width: 100%; /* era 100vw */
  height: 100%; /* era 100vh */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 100;
    pointer-events: none; /* No bloquea clics */
}

.timer-huge {
    font-size: 35vw; /* Ocupa el ancho para ser masivo */
    color: white;
    text-shadow: 0 20px 50px rgba(0, 0, 0, 0.131);
    margin: 0;
    padding: 0;
}

.timer-title {
    font-size: 3rem;
    color: white;
    background: rgba(0,0,0,0.4);
    padding: 10px 40px;
    border-radius: 50px;
    backdrop-filter: blur(10px);
}



.security-gate-wrapper {
  position: fixed;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center; /* Alinea botón y texto */
  z-index: 10000;
  pointer-events: none; /* El contenedor no atrapa el mouse */
}

.btn-lock-gate {
  pointer-events: auto;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.2); /* Borde sutil */
  
  /* ESTADO DESBLOQUEADO: Fondo translúcido tipo vidrio */
  background: rgba(255, 255, 255, 0.1); 
  backdrop-filter: blur(10px);
  color: rgba(255, 255, 255, 0.3); /* Icono casi invisible */
  
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  flex-shrink: 0;
}

.btn-lock-gate:hover{
  border: 1px solid white;
}

.btn-lock-gate.is-locked {
  /* ESTADO BLOQUEADO: Blanco sólido y brillante */
  background: #ffffff;
  color: #000000; /* Icono negro total */
  transform: scale(1.1);
  box-shadow: 0 0 25px rgba(255,255,255,0.4);
  border: none;
}

/* Efecto al pasar el mouse si está bloqueado */
.btn-lock-gate.is-locked:hover {
  background: #f0f0f0;
  transform: scale(1.15);
}

.security-info-tooltip {
  pointer-events: none;
  background: #ffffff; /* El PIN siempre en blanco sólido para legibilidad */
  color: black;
  padding: 0 15px;
  border-radius: 10px;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px; /* Igualamos al alto del botón para simetría */
  box-shadow: 0 10px 25px rgba(0,0,0,0.5);
  border-left: 4px solid #333; /* Un detalle visual extra */
}

.status-label {
  font-size: 8px;
  font-weight: bold;
  color: #888;
  letter-spacing: 1px;
}

.pin-displayed {
  font-size: 1.2rem;
  letter-spacing: 4px;
  color: #000;
}

/* Animación ajustada */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.2s ease-in;
}
.slide-fade-enter-from, .slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}





.btn-audio-pair {
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.2);
  color: white;
  padding: 8px 15px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;

}

/* --- HOVER EFECTO --- */
.btn-audio-pair:hover {
  background: #f8fafc;
  border-color: #ffffff;
  color: #000000;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(59, 246, 227, 0.15);
}

.btn-audio-pair.connected {
  background: #2ed573;
  border-color: #2ed573;
  box-shadow: 0 0 15px rgba(46, 213, 115, 0.4);
}



/* --- TRANSICIÓN ELÁSTICA PREMIUM --- */
.pill-slide-enter-active {
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275); /* Efecto bounce suave */
}
.pill-slide-leave-active {
  transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1); /* Salida suave */
}
.pill-slide-enter-from, .pill-slide-leave-to {
  transform: translate(-50%, -100px) scale(0.8);
  opacity: 0;
}

/* --- LA PÍLDORA (El contenedor principal de 60px) --- */
.audio-connection-pill {
  position: fixed;
  top: 30px; /* Separación del borde superior */
  left: 50%;
  transform: translateX(-50%);
  width: 480px; /* Un poco más ancha para dar aire */
  height: 60px; /* Alto fijo exacto */
  background: #ffffff;
  border-radius: 100px; /* Completamente redondeada como una píldora */
  z-index: 99999; /* Por encima de TODO */
  display: flex;
  align-items: center;
  padding: 0 10px 0 25px; /* Más padding a la izquierda */
  box-sizing: border-box;
  overflow: hidden;

  /* Sombra profunda pero muy suave (Soft Shadow) */
  box-shadow: 
    0 25px 50px rgba(0,0,0,0.15),
    0 10px 15px rgba(0,0,0,0.05);
  
  /* Sutil gradiente de arriba a abajo para dar volumen */
  background: linear-gradient(180deg, #ffffff 0%, #f9f9f9 100%);
  border: 1px solid rgba(0,0,0,0.02);
}

/* --- EL CONTENIDO INTERNO --- */
.pill-inner-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

/* --- BLOQUE IZQUIERDO (Estado y Texto) --- */
.pill-left-block {
  display: flex;
  align-items: center;
  gap: 15px;
}

.instruction-text {
  color: #666666; /* Texto gris suave, no negro puro */
  font-size: 14px;
  letter-spacing: -0.3px;
  font-weight: 500;
}

/* --- BLOQUE DERECHO (Código y Botón) --- */
.pill-right-block {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #000000; /* Fondo negro puro para contraste */
  height: 48px; /* Casi todo el alto */
  padding: 0 18px;
  border-radius: 100px; /* Contraste de píldora dentro de píldora */
  box-shadow: 0 5px 10px rgba(0,0,0,0.3);
}

.pairing-code {
  font-size: 32px; /* Código grande y pesado */
  color: #ffffff; /* Blanco puro sobre negro */
  letter-spacing: 5px; /* Mucho aire entre números */
  line-height: 1;
  font-weight: 800; /* Extra Bold */
  margin-top: -1px; /* Ajuste óptico de alineación */
}

/* --- BOTÓN DE CERRAR (En el bloque negro) --- */
.btn-close-pill {
  background: none;
  border: none;
  color: rgba(255,255,255,0.4); /* Gris oscuro sobre negro, sutil */
  cursor: pointer;
  font-size: 16px;
  padding: 5px;
  transition: all 0.2s;
}

.btn-close-pill:hover {
  color: #ff4757; /* Rojo neón en hover */
  transform: rotate(90deg);
}

/* --- INDICADOR DE ESTADO (El toque de color neón) --- */
.status-indicator {
  position: relative;
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-indicator .dot {
  width: 8px;
  height: 8px;
  background: #00d2ff; /* Color cian Uvoto */
  border-radius: 50%;
  display: block;
  z-index: 2;
}

/* Anillo de pulso neón */
.status-indicator .pulse-ring {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 210, 255, 0.4);
  border-radius: 50%;
  z-index: 1;
  animation: pulse-ring 1.8s infinite;
}

@keyframes pulse-ring {
  0% { transform: scale(1); opacity: 0.8; }
  80% { transform: scale(3.5); opacity: 0; }
  100% { transform: scale(3.5); opacity: 0; }
}

/* --- CLASES DE APOYO TIPOGRÁFICO --- */
.poppins-medium { font-family: 'Poppins', sans-serif; font-weight: 500; }
.poppins-extrabold { font-family: 'Poppins', sans-serif; font-weight: 800; }




.audio-live-container{
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  margin-bottom:4%;
}

.audio-live-box{
  text-align:center;
}

.audio-live-title{
  font-size:28px;
  margin-top:25px;
  font-weight:600;
}

.audio-live-sub{
  opacity:.7;
  margin-top:10px;
}

/* ondas de audio */

.audio-waves{
  display:flex;
  justify-content:center;
  align-items:flex-end;
  gap:8px;
  height:60px;
}

.audio-waves span{
  width:8px;
  height:20px;
  background:#4cafef;
  border-radius:6px;
  animation:wave 1.2s infinite ease-in-out;
}

.audio-waves span:nth-child(2){
  animation-delay:0.1s;
}

.audio-waves span:nth-child(3){
  animation-delay:0.2s;
}

.audio-waves span:nth-child(4){
  animation-delay:0.3s;
}

.audio-waves span:nth-child(5){
  animation-delay:0.4s;
}

@keyframes wave{

  0%,100%{
    height:20px;
  }

  50%{
    height:60px;
  }

}



.mic-icon {
  width: 20px;
  height: 20px;
}

.mic-icon .fill-white {
  fill: #FFFFFF;
}

.mic-icon .stroke-white {
  stroke: #FFFFFF;
  fill: none; /* Importante para que la base no se rellene de forma extraña */
}



/* Importante para que la base no se rellene de forma extraña */
.multi-results-container {
  width: 85%;
  margin: 40px auto;
  padding: 20px;
}

.multi-grid {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.multi-bar-item {
  width: 100%;
  animation: slideInRight 0.5s ease backwards;
}

.multi-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 8px;
}

.multi-label {
  font-size: 1.8rem;
  font-weight: 500;
  color: white;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.multi-percentage {
  font-size: 2rem;
  color: #fff;
}

.multi-progress-bg {
  height: 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  backdrop-filter: blur(5px);
}

.multi-progress-fill {
  height: 100%;
  border-radius: 20px;
  transition: width 1s cubic-bezier(0.22, 1, 0.36, 1);
  position: relative;
}

.glow-effect {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.795), transparent);
  animation: barGlow 2s infinite;
}

.multi-count {
  font-size: 0.9rem;
  opacity: 0.6;
  margin-top: 5px;
  text-align: right;
}

@keyframes barGlow {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@keyframes slideInRight {
  from { opacity: 0; transform: translateX(50px); }
  to { opacity: 1; transform: translateX(0); }
}

/* Contenedor del Cronómetro */
.proyector-timer-wrapper {
  top: 50%;
  right: 5%;
  width: 220px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;

}

.timer-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.timer-track {
  fill: none;
  stroke: rgba(255, 255, 255, 0.1);
  stroke-width: 8;
}

.timer-path {
  fill: none;
  stroke-width: 8;
  stroke-linecap: round;
  stroke-dasharray: 283;
  transition: stroke-dashoffset 1s linear, stroke 0.3s ease;
}

.timer-content {
  position: absolute;
  text-align: center;
  line-height: 1;
}

.timer-seconds {
  display: block;
  font-size: 8rem; /* Asegúrate de que los segundos sean enormes */
  color: v-bind('uiBrand.color'); /* Usa el color visual del proyector */
}

.timer-label {
  font-size: 1rem;
  color: rgba(255,255,255,0.5);
  letter-spacing: 3px;
  text-transform: uppercase;
}

/* Ajuste de la rejilla cuando hay cronómetro */
.multi-grid.with-timer-active {
  margin-right: 250px; /* Deja espacio para el círculo a la derecha */
  transition: margin 0.5s ease;
}

/* Animación crítica */
.critical-pulse {
  color: #ff5252 !important;
  animation: timer-beat 0.6s infinite alternate;
}

@keyframes timer-beat {
  from { transform: scale(1); }
  to { transform: scale(1.1); }
}



.is-correct .multi-progress-fill {
  box-shadow: 0 0 20px #4caf50 !important;
  animation: pulse-correct 1s infinite alternate;
}

.is-wrong {
  opacity: 0.5;
  filter: grayscale(0.8);
}

.quiz-winners {
  margin-top: 40px;
  text-align: center;
}

.with-timer-active {
  margin-top: 40px;
  opacity: 0.8; /* Hace que el foco sea el cronómetro */
}

.winners-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  margin-top: 15px;
}

.winner-pill {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255,255,255,0.15);
  padding: 8px 15px;
  border-radius: 50px;
  border: 1px solid rgba(255,255,255,0.3);
  animation: popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
}

.winner-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}

@keyframes pulse-correct {
  from { transform: scaleY(1); }
  to { transform: scaleY(1.1); }
}

@keyframes popIn {
  0% { transform: scale(0); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}


/* Vista de Votación Cerrada */
.closed-voting-view {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70vh; /* Centrado en el área de proyección */
  width: 100%;
  text-align: center;
      margin-top: -8%;
}

.closed-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-lock-wrapper {
  width: 80px;
  height: 80px;
  margin-bottom: 30px;
  opacity: 0.8;
}

.closed-title {
  font-size: 4.5rem;
  color: white;
  margin: 0;
  letter-spacing: 4px;
  text-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.closed-subtitle {
  font-size: 1.8rem;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 15px;
  font-weight: 300;
}

/* Animación de puntos de espera minimalistas */
.loading-dots-minimal {
  display: flex;
  gap: 10px;
  margin-top: 40px;
}

.loading-dots-minimal span {
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
  opacity: 0.3;
  animation: dots-fade 1.5s infinite;
}

.loading-dots-minimal span:nth-child(2) { animation-delay: 0.2s; }
.loading-dots-minimal span:nth-child(3) { animation-delay: 0.4s; }

@keyframes dots-fade {
  0%, 100% { opacity: 0.1; transform: scale(0.8); }
  50% { opacity: 0.6; transform: scale(1.2); }
}

/* Ajuste del Timer en blanco para modo pregunta */
.timer-track {
  stroke: rgba(255, 255, 255, 0.15);
}

.timer-seconds {
  color: white;
}

.results-view-gala {
  height: 50vh;
  width: 100%; /* era 100vw */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: visible;
  position: relative;
}

.reveal-container {
  margin-top: -20%;
  padding: 0 80px;
  box-sizing: border-box;
}

/* --- REVELACIÓN --- */
.reveal-answer {
  font-size: clamp(3rem, 8vw, 6rem); /* Se ajusta al tamaño de pantalla */
  color: #FFFFFF;
  text-align: center;
  text-shadow: 0 0 30px rgba(255, 255, 255, 0.6);
  z-index: 5;
}

/* --- FOOTER Y SLIDER --- */
.winners-footer {
  position: absolute;
  bottom: 80px;
  width: 100%;
  z-index: 10;
}

.slider-wrapper {
  overflow: hidden;
  width: 100%;
  /* Gradiente para que las tarjetas aparezcan/desaparezcan suavemente a los lados */
  mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
}

.slider-track {
  display: flex;
  width: max-content; /* IMPORTANTE: Permite que crezca horizontalmente */
  gap: 40px;
  padding: 20px;
}

/* Esta es la animación que hace el truco */
@keyframes scrollInfinito {
  0% { transform: translateX(50%); }
  100% { transform: translateX(-50%); }
}

/* Solo animar si hay suficientes para scrollear */
.slider-track {
  animation: scrollInfinito 30s linear infinite;
}

/* --- TARJETAS --- */
.winner-card-minimal {
  text-align: left;
  min-width: 150px; /* Ancho fijo para que no se colapsen */
  height: 100px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  padding: 0 30px;
  gap: 20px;
 
}

.user-photo {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0; /* Que no se aplaste la foto */
  border: 4px solid white;
}

.user-name {
  color: #ffffff;
  font-size: 1.8rem;
  white-space: nowrap; /* Que el nombre no salte de línea */
}

.user-tag {
  color: #ffffff; /* Un toque de verde solo en el texto pequeño */
  font-size: 0.9rem;
  display: block;
}

/* Cuando solo queremos enfocar el timer */
.timer-only-focus {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 50vh; /* Ocupa buen espacio visual */
  transition: all 0.5s ease;
}

.timer-only-focus .timer-seconds {
  font-size: 25vw; /* Tamaño masivo */
  line-height: 1;
  text-shadow: 0 10px 50px rgba(0, 0, 0, 0.081);
}

.timer-label-focus {
  font-size: 2rem;
  letter-spacing: 10px;
  opacity: 0.6;
  margin-top: -20px;
}

@keyframes pulse-timer {
  from { transform: scale(1); }
  to { transform: scale(1.05); }
}




/* Capa de fondo repetido con "Sabor" */
.logo-pattern-overlay {
  position: relative;
  /* Hacemos el contenedor un poco más grande que la pantalla para que al rotar no se vean las esquinas vacías */
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  
  pointer-events: none;
  z-index: 1; /* Ajustado para estar tras el contenido pero sobre el fondo base */
  
  /* Ajustes del Logo */
  background-repeat: repeat;
  background-size: 120px auto; /* Ancho fijo, alto automático para evitar recortes */
  background-position: center;


  /* Estética: Blanco y Negro con opacidad sutil */
  filter: brightness(0) invert(1); /* Convierte cualquier logo a blanco puro */
  opacity: 0.08; 

  /* El "Giro": Inclinamos todo el patrón 15 grados */
  transform: rotate(-15deg);
 

  /* La Animación: Desplazamiento infinito */
  animation: movePattern 120s linear infinite;
}



/* Animación para que los logos se muevan suavemente */
@keyframes movePattern {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 500px 1000px; /* Movimiento hacia abajo y derecha */
  }
}

/* Contenedor del nuevo sonar */
.badge-sonar-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    margin-left: 15px;
}






.logoCenter{
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  z-index: 59;

}






/* 🌊 ANIMACIÓN PRINCIPAL (default elegante) */
.anim-float-slow {
  animation: floatBokeh 12s ease-in-out infinite;
}

@keyframes floatBokeh {
  0% {
    background-position: 
      0% 50%,
      100% 50%,
      50% 100%;
  }

  50% {
    background-position: 
      100% 0%,
      0% 100%,
      50% 0%;
  }

  100% {
    background-position: 
      0% 50%,
      100% 50%,
      50% 100%;
  }
}


/* 🔥 MOVIMIENTO MÁS DINÁMICO */
.anim-move {
  animation: moveBokeh 20s ease-in-out infinite;
}

@keyframes moveBokeh {
  0% {
    background-position: 
      0% 50%,
      100% 50%,
      50% 100%;
  }

  50% {
    background-position: 
      100% 50%,
      0% 50%,
      50% 0%;
  }

  100% {
    background-position: 
      0% 50%,
      100% 50%,
      50% 100%;
  }
}


/* ✨ EFECTO GLOW / RESPIRACIÓN */
.anim-pulse {
  animation: pulseGlow 10s ease-in-out infinite;
}

@keyframes pulseGlow {
  0%, 100% { 
    opacity: 0.5;
  }
  50% { 
    opacity: 0.85;
  }
}

.moments-stage {
  --moments-frame-width: min(1380px, 92vw);
  --moments-frame-height: min(84vh, 900px);
  --moments-gap: clamp(16px, 2vw, 38px);
  --moments-shell-padding: clamp(16px, 1.5vw, 24px);
  --moments-copy-padding: clamp(22px, 2vw, 36px);
  --moments-photo-radius: clamp(20px, 2vw, 28px);
  --moments-shell-radius: clamp(24px, 2.6vw, 38px);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(18px, 3.6vh, 44px) clamp(18px, 4vw, 64px);
  box-sizing: border-box;
}

.moment-scene,
.moment-layout {
  width: min(100%, var(--moments-frame-width));
  height: min(100%, var(--moments-frame-height));
  max-width: 100%;
  max-height: 100%;
  border-radius: var(--moments-shell-radius);
}

.moments-stage.is-ultrawide {
  --moments-frame-width: min(1420px, 78vw);
  --moments-frame-height: min(78vh, 860px);
}

.moments-stage.is-standard-stage {
  --moments-frame-width: min(1380px, 92vw);
  --moments-frame-height: min(84vh, 900px);
}

.moments-stage.is-square-stage {
  --moments-frame-width: min(980px, 92vw);
  --moments-frame-height: min(88vh, 980px);
}

.moments-stage.is-portrait-stage {
  --moments-frame-width: min(760px, 92vw);
  --moments-frame-height: min(88vh, 1180px);
  --moments-gap: clamp(14px, 2vh, 22px);
}

.moments-stage.is-compact {
  --moments-frame-width: min(700px, 96vw);
  --moments-frame-height: min(90vh, 920px);
  --moments-gap: 12px;
  --moments-shell-padding: 14px;
  --moments-copy-padding: 18px;
}

.moment-layout {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.split-layout {
  gap: var(--moments-gap);
  align-items: center;
  height: 100%;
}

.moment-photo-shell {
  flex: 1.05;
  min-width: 0;
  height: 100%;
  background: rgba(255,255,255,0.08);
  border-radius: var(--moments-shell-radius);
  padding: var(--moments-shell-padding);
  box-shadow: 0 30px 70px rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
}

.moment-main-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: var(--moments-photo-radius);
}

.moment-copy-shell {
  flex: 0.95;
  min-width: 0;
  min-height: 68%;
  max-width: min(520px, 40vw);
  background: rgba(255,255,255,0.92);
  color: #111;
  border-radius: calc(var(--moments-shell-radius) - 4px);
  padding: var(--moments-copy-padding);
  box-shadow: 0 24px 50px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
}

.split-layout .moment-main-photo {
  object-fit: contain;
  background: #0b0b0b;
}

.moment-kicker {
  display: inline-flex;
  align-self: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(0,0,0,0.06);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1px;
  margin-bottom: 18px;
  text-align: center;
  width: auto;
  max-width: fit-content;
}

.moment-caption {
  font-size: clamp(30px, 3vw, 56px);
  line-height: 1.08;
  margin: 0 0 28px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.moment-author-row {
  display: flex;
  align-items: center;
  gap: 14px;
}

.moment-author-avatar {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  object-fit: cover;
}

.moment-author-avatar.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #111;
  color: #fff;
  font-weight: 800;
}

.moment-author-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.moment-author-meta span {
  color: #707070;
  font-size: 14px;
}

.polaroid-layout {
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: clamp(12px, 1.6vw, 18px);
  min-height: 100%;
  padding: clamp(12px, 1.6vh, 20px) 0;
  box-sizing: border-box;
}

.moment-polaroid-author-card {
  width: min(240px, 20vw);
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 18px 40px rgba(0,0,0,0.18);
}

.moment-polaroid-author-card .moment-author-avatar {
  flex-shrink: 0;
}

.moment-polaroid-author-card .moment-author-meta strong {
  color: #111;
  font-size: clamp(18px, 1.5vw, 24px);
  line-height: 1.15;
}

.polaroid-card {
  width: min(760px, 62vw);
  max-width: 100%;
  background: #fff;
  padding: 22px 22px 34px;
  border-radius: 16px;
  transform: rotate(-3deg);
  box-shadow: 0 28px 60px rgba(0,0,0,0.24);
  animation: polaroidFloat 5.8s ease-in-out infinite;
}

.polaroid-card.is-portrait {
  width: min(350px, 38vw);
}

.polaroid-card.is-landscape {
  width: min(860px, 72vw);
}

.polaroid-card .moment-main-photo {
  width: 100%;
  height: auto;
  max-height: min(68vh, 720px);
  border-radius: 10px;
  object-fit: cover;
  background: transparent;
  display: block;
}

.polaroid-card.is-portrait .moment-main-photo {
  max-height: min(62vh, 700px);
}

.polaroid-card.is-landscape .moment-main-photo {
  max-height: min(68vh, 760px);
}

.polaroid-caption {
  color: #111;
  font-size: clamp(24px, 2.2vw, 38px);
  font-weight: 700;
  margin-top: 22px;
}

.moment-polaroid-author {
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.cinematic-layout {
  overflow: hidden;
}

.moment-bg-blur {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: blur(34px) brightness(0.5);
  transform: scale(1.15);
  opacity: 0.75;
}

.moment-cinematic-card {
  position: relative;
  z-index: 1;
  width: min(100%, var(--moments-frame-width));
  min-height: min(100%, var(--moments-frame-height));
  display: grid;
  grid-template-columns: minmax(0, 1.06fr) minmax(320px, 0.94fr);
  gap: clamp(18px, 2vw, 28px);
  padding: clamp(16px, 1.8vw, 24px);
  border-radius: var(--moments-shell-radius);
  background: rgba(12, 12, 12, 0.48);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255,255,255,0.12);
  align-items: stretch;
}

.moment-cinematic-copy {
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.cinematic-photo {
  width: 100%;
  height: 100%;
  max-height: min(72vh, 760px);
  object-fit: cover;
}

.moment-cinematic-author {
  margin: 0;
  font-size: 20px;
  color: rgba(255,255,255,0.72);
}

.moments-stage.is-ultrawide .split-layout {
  width: min(100%, 1360px);
}

.moments-stage.is-ultrawide .moment-photo-shell {
  flex: 0 0 44%;
}

.moments-stage.is-ultrawide .moment-copy-shell {
  flex: 0 0 40%;
}

.moments-stage.is-ultrawide .polaroid-card.is-landscape {
  width: min(900px, 56vw);
}

.moments-stage.is-ultrawide .moment-cinematic-card {
  width: min(1360px, 76vw);
}

.moments-stage.is-square-stage .split-layout,
.moments-stage.is-portrait-stage .split-layout,
.moments-stage.is-compact .split-layout,
.moments-stage.is-square-stage .polaroid-layout,
.moments-stage.is-portrait-stage .polaroid-layout,
.moments-stage.is-compact .polaroid-layout {
  flex-direction: column;
  justify-content: center;
}

.moments-stage.is-square-stage .moment-photo-shell,
.moments-stage.is-portrait-stage .moment-photo-shell,
.moments-stage.is-compact .moment-photo-shell {
  width: min(100%, 560px);
  height: auto;
  max-height: 52vh;
  flex: 0 0 auto;
}

.moments-stage.is-square-stage .moment-copy-shell,
.moments-stage.is-portrait-stage .moment-copy-shell,
.moments-stage.is-compact .moment-copy-shell {
  width: min(100%, 620px);
  flex: 0 0 auto;
  max-width: min(100%, 620px);
}

.moments-stage.is-square-stage .moment-polaroid-author-card,
.moments-stage.is-portrait-stage .moment-polaroid-author-card,
.moments-stage.is-compact .moment-polaroid-author-card {
  width: min(100%, 420px);
  justify-content: center;
}

.moments-stage.is-square-stage .polaroid-card,
.moments-stage.is-portrait-stage .polaroid-card,
.moments-stage.is-compact .polaroid-card {
  width: min(100%, 520px);
  transform: rotate(-2deg);
}

.moments-stage.is-square-stage .polaroid-card .moment-main-photo,
.moments-stage.is-portrait-stage .polaroid-card .moment-main-photo,
.moments-stage.is-compact .polaroid-card .moment-main-photo {
  max-height: 52vh;
}

.moments-stage.is-square-stage .moment-cinematic-card,
.moments-stage.is-portrait-stage .moment-cinematic-card,
.moments-stage.is-compact .moment-cinematic-card {
  width: min(100%, 700px);
  grid-template-columns: 1fr;
}

.moments-stage.is-square-stage .cinematic-photo,
.moments-stage.is-portrait-stage .cinematic-photo,
.moments-stage.is-compact .cinematic-photo {
  max-height: 46vh;
}

.moments-stage.is-portrait-stage .moment-caption,
.moments-stage.is-compact .moment-caption {
  font-size: clamp(24px, 4.8vw, 42px);
}

.moments-stage.is-portrait-stage .polaroid-caption,
.moments-stage.is-compact .polaroid-caption {
  font-size: clamp(20px, 4vw, 30px);
}

.moments-fade-enter-active,
.moments-fade-leave-active {
  transition: all 0.45s ease;
}

.moments-fade-enter-from,
.moments-fade-leave-to {
  opacity: 0;
  transform: translateY(18px) scale(0.98);
}

.polaroid-swing-left-enter-active,
.polaroid-swing-left-leave-active,
.polaroid-swing-right-enter-active,
.polaroid-swing-right-leave-active {
  transition: opacity 0.7s ease, transform 0.9s cubic-bezier(0.22, 0.7, 0.2, 1);
}

.polaroid-swing-left-enter-from {
  opacity: 0;
  transform: translateX(-140px) rotate(-6deg) scale(0.96);
}

.polaroid-swing-left-leave-to {
  opacity: 0;
  transform: translateX(140px) rotate(5deg) scale(0.97);
}

.polaroid-swing-right-enter-from {
  opacity: 0;
  transform: translateX(140px) rotate(6deg) scale(0.96);
}

.polaroid-swing-right-leave-to {
  opacity: 0;
  transform: translateX(-140px) rotate(-5deg) scale(0.97);
}

@keyframes polaroidFloat {
  0% {
    transform: translateX(-10px) rotate(-3.8deg);
  }
  50% {
    transform: translateX(10px) rotate(-2.2deg);
  }
  100% {
    transform: translateX(-10px) rotate(-3.8deg);
  }
}

/* ═══════════════════════════════════════════════
   GANADORES — Podio + Leaderboard
═══════════════════════════════════════════════ */

.ganadores-scene {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: radial-gradient(ellipse at 50% 0%, #1e0a3c 0%, #0a0a18 70%);
  overflow: hidden;
  z-index: 10;
  padding: 40px 30px 0;
}

/* ── Partículas flotantes ── */
.ganadores-particles {
  position: fixed;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}
.gp-particle {
  position: absolute;
  border-radius: 50%;
  bottom: -20px;
  animation: gpFloat linear infinite;
}
@keyframes gpFloat {
  0%   { transform: translateY(0) rotate(0deg);    opacity: 0; }
  5%   { opacity: 1; }
  95%  { opacity: 0.6; }
  100% { transform: translateY(-105vh) rotate(540deg); opacity: 0; }
}

/* ── Cabecera podio ── */
.podio-kicker {
  position: relative;
  z-index: 1;
  font-size: 26px;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #FFD700;
  text-shadow: 0 0 24px rgba(255,215,0,0.55);
  margin-bottom: 8px;
}
.podio-mensaje {
  position: relative;
  z-index: 1;
  font-size: 20px;
  opacity: 0.65;
  margin-bottom: 32px;
  text-align: center;
}

/* ── Fila del podio ── */
.podio-row {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 0;
}

.podio-slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: podioEntrada 0.75s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}
@keyframes podioEntrada {
  from { opacity: 0; transform: translateY(50px) scale(0.82); }
  to   { opacity: 1; transform: translateY(0)    scale(1); }
}

/* Avatares */
.podio-avatar-wrap { position: relative; margin-bottom: 14px; }
.podio-avatar {
  border-radius: 50%;
  object-fit: cover;
  display: block;
}
.podio-avatar--oro    { width: 160px; height: 160px; border: 6px solid #FFD700; box-shadow: 0 0 34px rgba(255,215,0,0.45); }
.podio-avatar--plata  { width: 130px; height: 130px; border: 5px solid #C0C0C0; box-shadow: 0 0 18px rgba(192,192,192,0.3); }
.podio-avatar--bronce { width: 112px; height: 112px; border: 5px solid #CD7F32; box-shadow: 0 0 14px rgba(205,127,50,0.3); }

.podio-medal {
  position: absolute;
  bottom: -4px; right: -4px;
  font-size: 34px;
  line-height: 1;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.5));
}

/* Nombre */
.podio-nombre { text-align: center; margin-bottom: 4px; }
.podio-nombre--oro    { font-size: 38px; color: #fff; }
.podio-nombre--plata  { font-size: 30px; color: #e8e8e8; }
.podio-nombre--bronce { font-size: 26px; color: #ddd; }

/* Puntos */
.podio-pts { text-align: center; font-weight: 700; margin-bottom: 18px; }
.podio-pts--oro    { font-size: 22px; color: #FFD700; }
.podio-pts--plata  { font-size: 18px; color: #C0C0C0; }
.podio-pts--bronce { font-size: 16px; color: #CD7F32; }

/* Bloques del podio */
.podio-block {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px 14px 0 0;
}
.podio-block--oro    { width: 224px; height: 148px; background: linear-gradient(170deg, #f5c400, #d4a017 50%, #b8860b); }
.podio-block--plata  { width: 196px; height: 106px; background: linear-gradient(170deg, #d4d4d4, #a8a8a8 50%, #888); }
.podio-block--bronce { width: 178px; height: 74px;  background: linear-gradient(170deg, #e0915a, #b5622a 50%, #8b4513); }

.podio-block-num {
  font-size: 46px;
  font-weight: 900;
  color: rgba(0,0,0,0.28);
}

/* ═══ LEADERBOARD ═══ */
.lb-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
  width: min(920px, 90vw);
}
.lb-header-left {
  display: flex;
  align-items: center;
  gap: 18px;
}
.lb-trophy  { font-size: 60px; filter: drop-shadow(0 0 16px rgba(255,215,0,0.5)); }
.lb-title   { font-size: 54px; color: #fff; line-height: 1; }
.lb-subtitle {
  font-size: 14px;
  letter-spacing: 3px;
  text-transform: uppercase;
  opacity: 0.45;
  text-align: right;
  align-self: flex-end;
  padding-bottom: 8px;
}

.lb-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: min(920px, 90vw);
  max-height: 72vh;
  overflow-y: auto;
  position: relative;
  z-index: 1;
  scrollbar-width: none;
}
.lb-list::-webkit-scrollbar { display: none; }

.lb-row {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 14px 22px;
  border-radius: 20px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.08);
  backdrop-filter: blur(8px);
}
.lb-row--gold   { background: rgba(255,215,0,0.13);  border-color: rgba(255,215,0,0.28); }
.lb-row--silver { background: rgba(192,192,192,0.10); border-color: rgba(192,192,192,0.22); }
.lb-row--bronze { background: rgba(205,127,50,0.10);  border-color: rgba(205,127,50,0.22); }

.lb-pos   { width: 58px; text-align: center; flex-shrink: 0; }
.lb-medal { font-size: 38px; line-height: 1; }
.lb-num {
  display: inline-flex; align-items: center; justify-content: center;
  width: 42px; height: 42px;
  border-radius: 50%;
  background: rgba(255,255,255,0.13);
  font-size: 20px; font-weight: 800;
  color: #fff;
}
.lb-avatar { width: 66px; height: 66px; border-radius: 50%; object-fit: cover; flex-shrink: 0; }
.lb-info   { flex: 1; min-width: 0; text-align: left; }
.lb-nombre { font-size: 30px; color: #fff; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: left; }
.lb-sub    { font-size: 13px; opacity: 0.45; margin-top: 2px; text-align: left; }
.lb-pts    { font-size: 36px; color: #FFD700; text-align: right; white-space: nowrap; }
.lb-pts-unit { font-size: 18px; opacity: 0.7; }

/* ── PDF loading overlay ─────────────────────────────────────── */
.pdf-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.pdf-loading-bg {
  position: absolute;
  inset: -5%;          /* sobresale para que el blur no deje bordes blancos */
  background: #111827; /* fallback oscuro si no hay preview */
  background-size: cover;
  background-position: center;
  filter: blur(28px);
}

.pdf-loading-veil {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
}

.pdf-loading-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.pdf-loading-spinner {
  width: 68px;
  height: 68px;
  border: 5px solid rgba(255, 255, 255, 0.18);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: pdf-spin 0.75s linear infinite;
}

@keyframes pdf-spin {
  to { transform: rotate(360deg); }
}

.pdf-loading-text {
  color: rgba(255, 255, 255, 0.92);
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.4px;
  margin: 0;
}

.pdf-loader-fade-enter-active {
  transition: opacity 0.15s ease;
}
.pdf-loader-fade-leave-active {
  transition: opacity 0.5s ease;
}
.pdf-loader-fade-enter-from,
.pdf-loader-fade-leave-to {
  opacity: 0;
}

</style>
